/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-useless-concat */
/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, useRef} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import AddRemoveJadwal from './AddRemoveJadwal'
import {getSipNumber, getShow, getSipNumberSearch, getAccesses} from '../../../api/modules/kontrak'
import axios from 'axios'
import swal from 'sweetalert'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {editChildPlant} from '../../../api/modules/order'
import Pagination from '../component/Pagination'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import CustomUseEffect from './CustomUseEffect'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import {
  getMaterialGroup,
  getListMaterialAll,
  getDetailFileConfig,
} from '../../../api/modules/master-data/master'
import {
  getSalesAreaKontrak,
  getFilterCity,
  getCusGrup,
  getAccAss,
} from '../../../api/modules/master-data/master_2'
import Select from 'react-select'
import InputGroup from 'react-bootstrap/InputGroup'
import CurrencyInput from 'react-currency-input-field'
import {da, id} from 'date-fns/locale'
import {getCustomer} from '../../../api/modules/kontrak'
import {
  getPlant2,
  getProvince2,
  getProvince3,
  getTOPAnper,
  getTOPCust,
  getFindocDataTable,
  getFindocDataTableSearch,
  getSloc,
  getIncoterm,
  getSalesArea,
  getPayment,
  getEndUser,
  getUserDetail,
  getFooterContent,
  getSalesOfficeList,
  getAllPaymentList,
  getProductType,
  getProductName,
  getRoute,
  getCountryList,
} from '../../../api/modules/getdatalist'
import {set} from 'date-fns'
import Accordion from 'react-bootstrap/Accordion'
import {PopoverText, RichText} from '../../../components'
import {MultiSelect} from 'react-multi-select-component'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {TableBrowseSIP} from './TableBrowseSIP'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {
  addOrderItem,
  contractSelector,
  delOrderItem,
  putOrderItem,
  setOrderItem,
  setOrderItems,
} from '../../../redux/slices/contractSlices'
import Country from '../component/DataCountry.json'
import {TableBrowseCustomer} from './TableBrowseCustomer'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {BeforePPNKontrak, AfterPPNKontrak} from '../../../components/mikro/PPNCalculator'
import {appSelector} from '../../../redux/slices/appSlices'
import {authSelector} from 'src/redux/slices/authSlices'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import {TOrderItemContract, TOrderSubDetail} from 'src/redux/types'
import {Editor} from '@tinymce/tinymce-react'
import {stripHtmlTags} from 'src/components/mikro/stripHtmlTags'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import Skeleton from 'react-loading-skeleton'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'
import {getForModule} from 'src/api/modules/configuration/signing'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment, handleDownloadBase64 } from 'src/app/helpers/file'

const KontrakCreate: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {roleId} = useAppSelector(authSelector)
  const editorRef: any = useRef()
  const {sipFilter, customerFilter, orderItem, orderItems} = useAppSelector(contractSelector)
  const {selectedMenu} = useAppSelector(appSelector)
  const hakAkses = HakAkses()
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [show5, setShow5] = useState(false)
  const [show6, setShow6] = useState(false)
  const [show7, setShow7] = useState(false)
  const [showLetter, setShowLetter] = useState(false)
  const [loadingSkeleton, setLoadingSkeleton] = useState(false)

  const handleClose = () => {
    setTempDetail({})
    setShow(false)
  }
  const handleShow = () => setShow(true)
  const handleClose1 = () => (
    setShow1(false),
    setTitle(''),
    setCustomer_pic_name(''),
    setCustomer_pic_position(''),
    setTerms_and_conditions(''),
    setMail_body(''),
    setCustomer_attn(''),
    setPort_of_discharge(''),
    setLain_lain('')
  )
  const handleClose11 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose3 = () => (
    setShow3(false),
    setPlantt(''),
    setFullSloc([]),
    setslocId(''),
    setPlantt(''),
    setSalesOption(''),
    setShipContract('')
  )
  const handleShow3 = () => setShow3(true)
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => setShow4(true)
  const handleClose5 = () => setShow5(false)
  const handleShow5 = () => (setShow5(true), setCustomerShip(false))
  const handleClose6 = () => setShow6(false)
  const handleShow6 = () => setShow6(true)
  const handleClose7 = () => setShow7(false)
  const handleShow7 = () => setShow7(true)
  const handleCloseLetter = () => setShowLetter(false)
  const handleShowLetter = () => setShowLetter(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnLoadingA, setBtnLoadingA] = useState(false)
  const [accesses, setAccesses] = useState<any>()

  const [sipNum, setSipNum] = useState<any[]>([])
  const [showNum, setShowNum] = useState<any>()
  const [ordersubdetail, setordersubdetail] = useState<any[]>([])
  const [plantArray, setPlantArray] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [customer, setCustomer] = useState('')
  const [perihal, setPerihal] = useState('')
  const [estimate, setEstimate] = useState('')
  const [estimateFrom, setEstimateFrom] = useState('')
  const [assignerName, setassignerName] = useState('')
  const [assignerPos, setassignerPos] = useState('')
  const [initialAssignerName, setInitialAssignerName] = useState('')
  const [initialAssignerPos, setInitialAssignerPos] = useState('')
  const [incoterm, setIncoterm] = useState<any>()
  const [incoterm2, setIncoterm2] = useState('')
  const [orderSubDetail, setorderSubDetail] = useState<any>([])
  const [fixedPrice, setFixedPrice] = useState<any>()
  const [totalQuantum, setTotalQuantum] = useState<any>()
  const [beforePpn, setBeforePpn] = useState<any>()
  const [quantumApprove, setQuantumApprove] = useState<any>()

  const [totalQ, setTotalQ] = useState<any>()
  const [kantongApprove, setKantongApprove] = useState<any>()
  const [isUpload, setIsUpload] = useState(false)
  const [tempDetail, setTempDetail] = useState<any>({})

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [ppn, setppn] = useState(0)

  const [fullIncoterm, setFullIncoterm] = useState<any[]>([])
  const [salesOrg, setSalesOrg] = useState<any[]>([])
  const [salesOrgDesc, setSalesOrgDesc] = useState<any[]>([])
  const [fullProductType, setFullProductType] = useState([])

  const [cust, setCust] = useState<any[]>([])
  const [custAdd, setCustAdd] = useState<any[]>([])
  const [acc, setacc] = useState<any[]>([])
  const [accAdd, setAccAdd] = useState<any[]>([])

  const [title, setTitle] = useState('')
  const [customer_pic_name, setCustomer_pic_name] = useState('')
  const [customer_pic_position, setCustomer_pic_position] = useState('')
  const [terms_and_conditions, setTerms_and_conditions] = useState('')
  const [mail_body, setMail_body] = useState('')
  const [customer_attn, setCustomer_attn] = useState('')
  const [port_of_discharge, setPort_of_discharge] = useState('')
  const [lain_lain, setLain_lain] = useState('')

  const [fullProvince2, setFullProvince2] = useState<any>([])
  const [provinceDesc, setProvinceDesc] = useState('')
  const [province, setProvince] = useState(0)
  const [fullCity2, setFullCity2] = useState<any>([])
  const [cityDesc, setCityDesc] = useState('')
  const [ptype2, setPtype2] = useState('')
  const [punit, setPunit] = useState('')
  const [ptype, setPtype] = useState<any>('')
  const [fullProductName, setFullProductName] = useState<any[]>([])
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [subprice, setSubprice] = useState<any>(0)
  const [quantum, setQuantum] = useState<any>(0)
  const [warehouse, setWarehouse] = useState('')
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay2, setPay2] = useState('')
  const [shipping, setShipping] = useState<any>(0)
  const [shipContract, setShipContract] = useState<any>('')
  const [pay1Desc, setPay1Desc] = useState('')
  const [pay2Desc, setPay2Desc] = useState('')
  const [fullPayment, setFullPayment] = useState([])
  const [keterangan, setketerangan] = useState('')
  const [fullSegment, setFullSegment] = useState<any[]>([])
  const [segment, setSegment] = useState<any>('')
  const [segmentDesc, setSegmentDesc] = useState<any>('')
  const [pspec, setPspec] = useState('')
  const [custName, setCustName] = useState('')
  const [custNum, setCustNum] = useState('')
  const [enduserDesc, setEnduserDesc] = useState('')
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [noExport, setNoExport] = useState('')
  const [noExportt, setNoExportt] = useState('')
  const [keterangann, setKeterangann] = useState('')
  const [textPenutup, setTextPenutup] = useState('')
  const [fileBox, setFileBox] = useState<any>({})

  const [datenow, setDateNow] = useState('')
  let tempkey = 0
  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]
  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempTanggal, setTempTanggal] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [tempData, setTempData] = useState({
    schedules: [],
    attachments: [],
  })
  const [index2, setIndex2] = useState(0)
  const [index3, setIndex3] = useState(0)
  const [listYear, setListYear] = useState<any[]>([])
  const [taking, setTaking] = useState(0)
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [countryList, setCountryList] = useState<any[]>([])

  const [disableCKBOX, setDisableCKBOX] = useState(false)
  const separateValue4 = (value: any, state: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    if (temp[0] != 0) setDisableCKBOX(true)
    else setDisableCKBOX(false)
  }

  const separator2 = (value: any, func1: any, func2: any) => {
    const temp = value.split('~#~')
    func1(temp[0])
    func2(temp[1])
  }
  const [tooltip, setTooltip] = useState('Open')

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('foldd-open')
  }

  useEffect(() => {
    const getSipNum = async () => {
      setLoading(true)
      const res = await getSipNumber(localStorage.getItem('credential'))
      const data = res.data.data.data
      setSipNum(data)
      setLoading(false)
    }

    const getInco = async () => {
      const res = await getIncoterm()
      const data = res.data.data.data

      setFullIncoterm(
        res.data.data.map((item: any) => {
          return {
            value: item.id,
            label: item.code,
          }
        })
      )
    }

    const getCust = async () => {
      const res = await getCusGrup()
      setCust(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }

    const getAcc = async () => {
      const res = await getAccAss()
      setacc(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }

    const getType = async () => {
      const res = await getProductType()
      setFullProductType(res.data.data)
    }

    const getprov = async () => {
      await getProvince3().then((res) => {
        setFullProvince2(
          res.data.data.map((item: any) => {
            return {
              value: parseInt(item.sales_office) + '~#~' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
    }

    const getAllPayment = async () => {
      await getAllPaymentList().then((res) => {
        setFullPayment(res.data.data)
      })
    }

    const getSegment = async () => {
      await getCusGrup().then((res) => {
        setFullSegment(res.data.data)
      })
    }

    const getEndUserr = async () => {
      await getEndUser('').then((res) => {
        setFullEndUser(res.data.data)
      })
    }

    const getCountryy = async () => {
      await getCountryList().then((res) => {
        setCountryList(
          res.data.data.map((item: any) => {
            return {
              value: item.code + '~#~' + item.name,
              label: item.name,
            }
          })
        )
      })
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getCountryy()
    getEndUserr()
    getSegment()
    getAllPayment()
    getprov()
    getType()
    getAcc()
    getCust()
    getInco()
    getSipNum()
    getAllRoleList()
  }, [])

  const [userDetail, setUserDetail] = useState<any>()
  const [footer, setFooter] = useState<any>()

  CustomUseEffect(() => {
    const getUser = async () => {
      await getUserDetail(sektorid, cusCode).then((res: any) => {
        setUserDetail(res.data.data)
      })
    }

    const getFooter = async () => {
      await getFooterContent(salesOrg, 'contract').then((res: any) => {
        setFooter(res.data.data)
      })
    }

    getFooter()
    getUser()
  }, [showNum])

  CustomUseEffect(() => {
    const getFUllSalesOffice = async () => {
      await getFilterCity(province)
        .then((res) => {
          setLoading(true)
          setFullCity2(
            res.data.data.map((item: any) => {
              return {
                value: item.id + '~#~' + item.value,
                label: item.value,
              }
            })
          )
        })
        .finally(() => setLoading(false))
    }

    getFUllSalesOffice()
  }, [province])

  CustomUseEffect(() => {
    let tempsektor = ''
    if (idSektor != 0) tempsektor = String(idSektor)
    const productNameData = async () => {
      await getProductName(warehouse, dist, ptype, salesOrg, tempsektor).then((res) => {
        let temp: any[] = []
        res.data.data.map((item: any) => {
          if (item.material_number != 0) {
            temp.push({
              value: item.material_number + '~#~' + item.material_description + '~#~' + item.unit,
              label: parseInt(item.material_number) +' - '+item.material_description,
              truevalue: parseInt(item.material_number),
            })
          }
        })
        setFullProductName(temp)
      })
    }
    productNameData()
  }, [ptype2])

  const [dist, setDist] = useState<any>('')
  const [sektorid, setsektorid] = useState(0)
  const [companyCode, setCompanyCode] = useState<any>('')
  const [sipNumber, setSipNumber] = useState<any>('')

  const [tempIndex, setTempIndex] = useState(0)
  const [payloadSloc, setPayloadSloc] = useState<any[]>([])
  const [payloadSlocDesc, setPayloadSlocDesc] = useState<any[]>([])
  const [payloadPlantID, setPayloadPlantID] = useState<any[]>([])
  const [payloadPlantDesc, setPayloadPlantDesc] = useState<any[]>([])
  const [payloadType, setPayloadType] = useState<any[]>([])
  const [payloadDesc, setPayloadDesc] = useState<any[]>([])
  const [payloadName, setPayloadName] = useState<any[]>([])
  const [payloadMaterial, setPayloadMaterial] = useState<any[]>([])
  const [payloadUnit, setPayloadUnit] = useState<any[]>([])
  const [payloadID, setPayloadID] = useState<any[]>([])
  const [payloadSpec, setPayloadSpec] = useState<any[]>([])
  const [payloadQuantum, setPayloadQuantum] = useState<any[]>([])
  const [payloadHarga, setPayloadHarga] = useState<any[]>([])
  const [payloadProvince, setPayloadProvince] = useState<any[]>([])
  const [payloadCity, setPayloadCity] = useState<any[]>([])
  const [payloadEndUser, setPayloadEndUser] = useState<any[]>([])
  const [payloadEndUserId, setPayloadEndUserId] = useState<any[]>([])
  const [payloadNotes, setPayloadNotes] = useState<any[]>([])
  const [payloadPayNotes, setPayloadPayNotes] = useState<any[]>([])
  const [payloadSeg, setPayloadSeg] = useState<any[]>([])
  const [payloadSegDesc, setPayloadSegDesc] = useState<any[]>([])
  const [payloadShipping, setPayloadShipping] = useState<any[]>([])
  const [payloadInclude, setPayloadInclude] = useState<any[]>([])
  const [payloadJadwal, setPayloadJadwal] = useState<any[]>([])
  const [payloadPPH22, setPayloadPPH22] = useState<any>(0)
  const [payloadFullPlant, setPayloadFullPlant] = useState<any[]>([])
  const [isNoEnduser, setIsNoEnduser] = useState(false)
  const [arrayEnduser, setEnduserArray] = useState<any[]>([])
  const [enduser, setEnduser] = useState('')
  const [p1, setP1] = useState('')
  const [p11, setP11] = useState('')
  const [p2, setP2] = useState('')
  const [p22, setP22] = useState('')
  const [addedProduct, setAddedProduct] = useState<any[]>([])
  const [tempItems, setTempItems] = useState<any[]>([])
  const [ptypee, setPtypee] = useState<any>('')
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])

  // Add Product
  const [incotermId, setIncotermId] = useState<any>(0)
  const [incotermIdDesc, setIncotermIdDesc] = useState<any>('')
  const [incotermId2, setIncotermId2] = useState('')
  const [incotermId2Desc, setIncotermId2Desc] = useState('')
  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()

  const [cusName, setCusName] = useState<any>('')
  const [cusCode, setCusCode] = useState<any>('')
  const [cusTitle, setCusTitle] = useState<any>('')
  const [cusId, setCusId] = useState<any>('')
  const [handleSub, setHandleSub] = useState<any>(false)

  const [signingPayload, setSigningPaylod] = useState({
    module: 'SKPP',
    sector_id: '',
    total_quantum: 0,
    province_id: '',
    city_id: '',
    sales_org_code: '',
    product_type: ''
  })

  const localId = async (sip: any, number: any, detail: any) => {
    setSipNumber(number)
    if (sip !== null) {
      handleClose2()
    }
    setCusId(sip)
    await getShow(sip, localStorage.getItem('credential')).then((res: any) => {
      const data = res.data.data
      setassignerName(res.data.data.signer_name)
      setassignerPos(res.data.data.signer_position)
      setShowNum(res.data.data)
      setEstimate(res.data.data?.valid_date_to.slice(0, 10))
      setEstimateFrom(res.data.data?.valid_date_from.slice(0, 10))
      setCusName(res.data.data.customer.name)
      setCusCode(res.data.data.customer.customer_code)
      setCusTitle(res.data.data.customer.title)
      setordersubdetail(res.data.data.order_sub_details)
      setCustomer(res.data.data.customer_id)
      setPerihal(res.data.data.perihal)
      setDist(res.data.data?.pengajuan_order?.distribution_channel)
      setCustomerCode(res.data.data?.customer?.customer_code)
      setCustomerName(res.data.data?.customer?.name)
      setCustomerAddress(res.data.data?.customer?.address)
      setCompanyCode(res.data.data?.anper?.code)
      setsektorid(res.data.data.sector_id)
      setSalesOrg(res.data.data?.sales_org_code)
      getImg(res.data.data.sales_org_code)
      setSalesOrgDesc(res.data.data?.order_sub_details[0]?.produsen?.name)
      setIncotermIdDesc(res.data.data.order_sub_details[0]?.incoterm1?.code)
      setIncotermId(res.data.data.order_sub_details[0]?.incoterm1?.id)
      setIncotermId2Desc(
        res.data.data.order_sub_details[0]?.incoterm2
          ? res.data.data.order_sub_details[0]?.incoterm2?.code
          : data.order_sub_details[0]?.incoterm2_id
      )
      // setAddedProduct(res.data.data.order_sub_details)
      setTempItems(detail)
      setPayloadPPH22(data?.order_sub_details[0]?.pph22)
      setppn(res.data.data.order_sub_details[0]?.ppn)

      setCityKontrak([])
    })
    handleRemoveAll()
    setLoading(false)
  }

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  const [fullCustomer, setFullCustomer] = useState<any>([])
  const [numberURL3, setNumberURL3] = useState([])
  const [customerr, setCustomerr] = useState('')
  const [customerrName, setCustomerrName] = useState('')
  const [customerShip, setCustomerShip] = useState(false)
  const [provinsii, setProvinsii] = useState('')
  const [provinsiiDesc, setProvinsiiDesc] = useState('')
  const [countryDest, setCountryDest] = useState('')
  const [countryId, setCountryId] = useState('')

  const handleCustomer = async () => {
    setCustName('')
    setCustNum('')
    await getCustomer(salesOrg, '', '', dist).then((res: any) => {
      setFullCustomer(res.data.data.data)
      setNumberURL3(res.data.data.links)
    })
    handleShow5()
  }

  const paginateNumber2 = async (number: any) => {
    const sales_org_code = customerFilter?.sales_org_code ?? ''
    const customer_code = customerFilter?.customer_code ?? ''
    const name = customerFilter?.name ?? ''

    const res = await axios.get(
      `${number}&sales_org_code=${sales_org_code}&customer_code=${customer_code}&name=${name}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setFullCustomer(res.data.data.data)
    setNumberURL3(res.data.data.links)
  }

  const handleUser = (data: any) => {
    let result: any[] = []
    data.forEach((data: any) => {
      result.push(data.value)
    })
    return result
  }

  useEffect(() => {
    const getData = setTimeout(async () => {
      const sales_org_code = customerFilter?.sales_org_code ?? ''
      const customer_code = customerFilter?.customer_code ?? ''
      const name = customerFilter?.name ?? ''
      const distribution_channel = customerFilter?.distribution_channel ?? ''

      await getCustomer(sales_org_code, customer_code, name, distribution_channel).then(
        (res: any) => {
          setFullCustomer(res.data.data.data)
          setNumberURL3(res.data.data.links)
        }
      )
    }, 1000)

    return () => clearTimeout(getData)
  }, [customerFilter])

  // CustomUseEffect(() => {
  //   handleCustomer()
  //   paginateNumber2(numberURL3)
  // }, [salesOrg])

  CustomUseEffect(() => {
    handleClose5()
  }, [customerr])

  // payloadQuantum[tempIndex] *
  // (payloadHarga[tempIndex] + payloadHarga[tempIndex] / 100)

  const [salesArea, setSalesArea] = useState<any[]>([])
  const [prov, setProv] = useState<any[]>([])
  const [salesAreaCode, setSalesAreaCode] = useState<any>()

  CustomUseEffect(() => {
    const getSalesArea = async () => {
      await getSalesAreaKontrak(dist, salesOrg).then((res: any) => {
        setSalesArea(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office.slice(-2),
              label: item.description,
            }
          })
        )
      })
    }

    const getAllProvince = async () => {
      await getProvince3().then((res) => {
        setProv(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office.slice(-2) + '~#~' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
    }
    getAllProvince()
    getSalesArea()
  }, [tempItems])

  const [cityKontrak, setCityKontrak] = useState<any[]>([])
  const [cityData, setCityData] = useState('')

  CustomUseEffect(() => {
    setCityKontrak([])
    setCityData('')
    const getCity = async () => {
      await getFilterCity(salesAreaCode).then((res: any) => {
        setCityKontrak(
          res.data.data.map((item: any) => {
            return {
              value: item.id,
              label: item.value,
            }
          })
        )
      })
    }
    getCity()
  }, [salesAreaCode])

  const lang = i18next.language

  const postKontrak = async () => {
    swal({
      title: `${t('apakahAndaYakin create Contract')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willCreate) => {
        if (willCreate) {
          const btn = document.getElementById('addKontrak')
          if (btn) {
            btn.setAttribute('disabled', 'disabled')
          }
          const a: any[] = []
          submitOrder.forEach((data: any, index: any) => {
            a.push(data)
            data?.attachments?.forEach((data2: any, index2: any) => {
              if (data?.attachments?.length > -1) {
                const temp = data2?.file_r?.split(',')
                a[index].attachments[index2].file_r = temp[1]
              }
            })
          })

          const payload: any = []
          addedProduct.forEach((data: any, _index: any) => {
            payload.push({
              incoterm1_id: incotermId,
              incoterm2_id: incotermId2Desc,
              sales_org_code: salesOrg,
              sector_id: sektorid,
              id: payloadID[_index],
              plant: payloadPlantID[_index],
              plant_desc: payloadPlantDesc[_index],
              sloc: payloadSloc[_index],
              sloc_description: payloadSlocDesc[_index],
              product_type: payloadType[_index],
              product_type_desc: payloadDesc[_index],
              product_name: payloadName[_index],
              material_number: payloadMaterial[_index],
              unit: payloadUnit[_index],
              product_spec: payloadSpec[_index],
              fixed_quantum: payloadQuantum[_index],
              fixed_price: payloadHarga[_index],
              city_id: payloadCity[_index],
              province_id: parseInt(data.province_id),
              end_user: data.end_user,
              end_user_multiple: data.end_user_multiple,
              notes: payloadNotes[_index],
              payment_type_1: p11,
              payment_type_1_desc: p1,
              payment_type_2: p22,
              payment_type_2_desc: p2,
              payment_note: payloadPayNotes[_index],
              segment_code: payloadSeg[_index],
              segment_name: payloadSegDesc[_index],
              shipping_tolerance: payloadShipping[_index],
              include_ppn: payloadInclude[_index],
              at_sales_option: data.at_sales_option,
              schedules: submitOrder[_index]?.schedules,
              attachments: submitOrder[_index]?.attachments,
              shipping_tolerance_contract: orderItems.map((item) => {
                const shipping_tolerance_contract = item?.shipping_tolerance_contract || 0
                return {...item, shipping_tolerance_contract}
              })[_index].shipping_tolerance_contract || 0,
              material_desc_en: data.material_desc_en,
              plant_desc_en: data.plant_desc_en,
            })
          })
          setBtnLoading(true)
          axios
            .post(
              `${
                process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
              }/contract/store?credentials=${localStorage.getItem('credential')}`,
              {
                sip_order_id: cusId,
                customer: customer,
                sales_office: salesAreaCode,
                sales_group: cityData,
                perihal: perihal,
                validity_date_from: estimateFrom,
                validity_date_to: estimate,
                total_quantum: totalQ,
                total_price: totalQuantum,
                grand_total: fixedPrice,
                assigner_name: assignerName,
                assigner_position: assignerPos,
                incoterm1: incoterm,
                incoterm2: incoterm2,
                order_sub_details: payload,
                title: titlee,
                title_en: titleeEn,
                customer_pic_name: customer_pic_namee,
                customer_pic_position: customer_pic_positionn,
                terms_and_conditions: terms_and_conditionss,
                terms_and_conditions_en: terms_and_conditionssEn,
                mail_body: mail_bodyy,
                mail_body_en: mail_bodyyEn,
                customer_attn: customer_attnn,
                customer_attn_en: customer_attnnEn,
                port_of_discharge: port_of_dischargee,
                lain_lain: lain_lainn,
                lain_lain_en: lain_lainnEn,
                keterangan: keterangannn,
                keterangan_en: keterangannnEn,
                text_penutup: textPenutupp,
                text_penutup_en: textPenutuppEn,
                customer_ship_to: customerr,
                province: provinsii,
                province_desc: provinsiiDesc,
                country_destination: countryDest,
                country_destination_code: countryId,
                lang: lang,
                no_izin_export: noExportt,
                credentials: localStorage.getItem('credential'),
                doc_is_inc_ppn: includePPN
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            .then((response) => {
              if (!response.data.error) {
                setIsUpload(true)

                swal({
                  title: `${t('contract added successfully')}`,
                  icon: 'success',
                }).then(() => {
                  navigate(`/management/kontrak`)
                })
              }
            })
            .catch((error) => {
              swal({
                title: t(error.response.data.message),
                icon: 'error',
              })
            })
            .finally(() => {
              setBtnLoading(false)
            })
        }
      })
      .catch((err) => {})
  }

  const [fullPlant, setFullPlant] = useState<any[]>([])
  const [plant, setPlant] = useState('')
  const [plantDesc, setPlantDesc] = useState('')
  const [sales, setSales] = useState('')
  const [city, setCity] = useState(0)
  const [roleUser] = useState(localStorage.getItem('role-flag')!)
  const [matgroup, setMatgroup] = useState('')
  const [matgroupdesc, setMatgroudesc] = useState('')
  const [matNumber, setMatNumber] = useState('')
  const [matUnit, setMatUnit] = useState('')
  const [matDesc, setMatDesc] = useState('')

  const [plantName, setPlantName] = useState('')
  const [plantNameEn, setPlantNameEn] = useState('')
  const [plantID, setPlantID] = useState('')
  const [editPlant, setEditPlant] = useState('')
  const [idItem, setIdItem] = useState('')
  const [editSloc, setEditSloc] = useState<any>('')
  const [slocId, setslocId] = useState<any>('')
  const [editProduct, setEditProduct] = useState<any>('')
  const [editMaterial, setEditMaterial] = useState<any>('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [productNameEn, setProductNameEn] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [spec, setSpec] = useState<any>('')
  const [salesOption, setSalesOption] = useState<any>('')
  const [quantumEdit, setQuantumEdit] = useState<any>('')
  const [hargaEdit, setHargaEdit] = useState<any>('')
  const [kuantumSisa, setKuantumSisa] = useState<any>(0)
  const [pro, setpro] = useState<any>('')
  const [deletee, SetDeletee] = useState<any>('false')

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      let language = i18next.language
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const separator = (value: any, state1: any, state2: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
  }

  const [sloc, setSloc] = useState<any>('')
  const [fullsloc, setFullSloc] = useState<any[]>([])
  const [listMaterial, setListMaterial] = useState<any>()
  const [listProduct, setListProduct] = useState<any>()
  const [indexMat, setIndexMat] = useState<any>('')
  const [trigger, setTrigger] = useState<any>(0)
  const [triggerr, setTriggerr] = useState<any>(0)

  const handleEdit = async (saless: any, mat: any, plantt: any, matGroup: any) => {
    handleShow3()

    let planttt = plantt != null ? plantt : ''
    setLoading(true)
    setIndexMat(mat)

    setFullSloc([])
    let language = i18next.language
    await getPlant2(saless, dist, mat).then((res) => {
      let temparray: any[] = [{value: 0 + '~#~', label: t('Pilih-plant')}]
      res.data.data.forEach((item: any) => {
        temparray.push({
          value: item.plant + '~#~' + item.plant_name,
          label: item.plant + ' - ' + item.plant_name,
        })
      })
      setFullPlant(temparray)
    })
    await getSloc(planttt, language, mat, fq, matGroup)
      .then((res) => {
        setFullSloc(res.data.data)
      })
      .catch((err) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
        setFullSloc([])
      })
    await getMaterialGroup().then((res) => {
      setListMaterial(res.data.data)
    })
    await getListMaterialAll(planttt, dist, companyCode, matGroup).then((res) => {
      let tempArray: any[] = [{value: 0 + '~#~', label: t('Pilih-productName')}]
      res.data.data.forEach((item: any) => {
        tempArray.push({
          unit: item.base_of_measure,
          value: item.material_description + '~#~' + item.material_number,
          label: parseInt(item.material_number) + " - " +item.material_description,
        })
      })
      setListProduct(tempArray)
    })
    setLoading(false)
  }

  const [fq, setFq] = useState('')

  CustomUseEffect(() => {
    const getPlantLoc = async () => {
      let language = i18next.language

      await getSloc(plant, language, matNumber, fq, matgroup)
        .then((res) => {
          setFullSloc(res.data.data)
        })
        .catch((err) => {
          if(err.response.data){
            swal({
              title: t(err.response.data.message),
              icon: 'error',
            })
          }
          setFullSloc([])
        })
    }
    getPlantLoc()
  }, [plant, matNumber, matgroup])

  CustomUseEffect(() => {
    if (trigger == 1) {
      setTriggerr(0)
    } else {
      setTriggerr(1)
    }

    const sloc = document.getElementById('sloccc') as HTMLSelectElement
    if (sloc != null) sloc.selectedIndex = 0
    setslocId('')

    const getListMat = async () => {
      await getListMaterialAll(plant, dist, companyCode, matgroup).then((res) => {
        let tempArray: any[] = [{value: 0 + '~#~', label: t('Pilih-productName')}]
        res.data.data.forEach((item: any) => {
          tempArray.push({
            unit: item.base_of_measure,
            value: item.material_description + '~#~' + item.material_number,
            label: parseInt(item.material_number) + " - " + item.material_description,
          })
        })
        setListProduct(tempArray)
      })
    }

    getListMat()
  }, [plant, matgroup])

  const [sog, setSog] = useState<any>('')

  CustomUseEffect(() => {
    const getPlantt = async () => {
      setFullPlant([])
      await getPlant2(sog, dist, matNumber).then((res) => {
        let temparray: any[] = [{value: 0 + '~#~', label: t('Pilih-plant')}]
        res.data.data.forEach((item: any) => {
          temparray.push({
            value: item.plant + '~#~' + item.plant_name,
            label: item.plant + ' - ' + item.plant_name,
          })
        })
        setFullPlant(temparray)
      })
    }

    const getSlocc = async () => {
      await getSloc(plant, language, matNumber, fq, matgroup)
        .then((res) => {
          setFullSloc(res.data.data)
        })
        .catch((err) => {
          if(err.response.data){
            swal({
              title: t(err.response.data.message),
              icon: 'error',
            })
          }
          setFullSloc([])
        })
    }

    if (trigger == 1) {
      setTrigger(0)
    } else {
      setTrigger(1)
    }
    getSlocc()
    getPlantt()
  }, [matNumber])

  const updatePlant = async (id: any, index: any) => {
    let tempArray = {
      plant: '',
      plant_desc: '',
    }
    tempArray = showNum
    tempArray.plant = plant
    tempArray.plant_desc = plantDesc

    const lang = i18next.language

    const res = await editChildPlant(id, {plant: plant, plant_desc: plantDesc, lang: lang})

    if (!res.data.error) {
      swal({
        title: `${t('gudangTelahBerhasilDiRubah')}`,
        icon: 'success',
      })
      setShow1(false)
    } else
      swal({
        title: `${res.data}`,
        icon: 'error',
      })
  }

  const [showJadwal, setShowJadwal] = useState(false)
  const [showJadwal1, setShowJadwal1] = useState(false)
  const [jadwalID, setJadwalID] = useState('')

  const [numberURL, setNumberURL] = useState([])

  const paginateNumber = async (number: any) => {
    const SIP_number = sipFilter?.SIP_number ?? ''
    const customer_name = sipFilter?.customer_name ?? ''
    const sector_id = sipFilter?.sector_id ?? ''
    const res = await axios.get(
      `${number}&credentials=${localStorage.getItem(
        'credential'
      )}&SIP_number=${SIP_number}&customer_name=${customer_name}&sector_id=${sector_id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setSipNum(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getSipNumberSearch(
        localStorage.getItem('credential'),
        sipFilter?.SIP_number ?? '',
        sipFilter?.customer_name ?? '',
        sipFilter?.sector_id ?? '',
        sipFilter?.product_type ?? ''
      ).then((res: any) => {
        setSipNum(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [sipFilter])
  //#endregion

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')

  const ambilAttachment = async (id: any) => {
    setLoadingSkeleton(true)
    await getFile('order-item', id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
    })
    setLoadingSkeleton(false)
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (selectedMenu?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate1 = document.getElementById('isPrivate1') as HTMLInputElement
    if (inputPrivate1 != null) inputPrivate1.checked = false

    const inputPrivate2 = document.getElementById('isPrivate2') as HTMLInputElement
    if (inputPrivate2 != null) inputPrivate2.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoadingA(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('unique_number', sipNumber)
    formdata.append('unique_flag', 'new_sip_osd')
    await create('order-item', formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setTempRole([])
          setIsPrivate(false)
          setFiles({file: null})
          clearFile()
        })
        ambilAttachment(subOrderID)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoadingA(false)
      })
  }

  const checkMandatory = () => {
    if (plant == '' || plant == '0') return t('isi') + t('sub-order-gudang')
    else if (sloc == '' || sloc == '0') return t('isi') + t('sloc')
    else if (sloc == '' || sloc == '0') return t('isi') + t('sloc')
    else if (sloc == '' || sloc == '0') return t('isi') + t('sloc')
    else if (matgroupdesc != 'KANTONG/SACK' && (hargaEdit == '' || isNaN(hargaEdit)))
      return t('isi') + t('harga')
    else if (shipContract < 0) return t('shipping tolerance tidak boleh minus')
    else if (shipContract > 100) return t('Shipping tolerance melebihi 100%')
    else if (quantumEdit > kuantumSisa) return t('CREATE_CONTRACT.VALIDATE.EDIT_CONTRACT')
    else if (sector == '3' && (!plantNameEn || plantNameEn == '')) return t('isi') + t('sub-order-gudang') + ' (EN)'
    else if (sector == '3' && (!productNameEn || productNameEn == '')) return t('isi') + t('sub-order-produk') + ' (EN)'
    else return 'nothing'
  }

  const [editSave, setEditSave] = useState('false')

  const handleEditPlant = async () => {
    const mandatory = checkMandatory()
    if (mandatory == 'nothing') {
      let tempPrice = 0
      if (hargaEdit == '' || isNaN(hargaEdit)) tempPrice = 0
      else tempPrice = parseFloat(hargaEdit)

      const newArray = [...addedProduct]
      newArray[tempIndex] = {
        ...newArray[tempIndex],
        product_name: matDesc,
        at_sales_option: salesOption || undefined,
        shipping_tolerance_contract: shipContract,
        material_desc_en: productNameEn,
        plant_desc_en: plantNameEn
      }

      setAddedProduct(newArray)
      const temparray: any[] = [...payloadPlantID]
      const temparray2: any[] = [...payloadPlantDesc]
      const temparray3: any[] = [...payloadSloc]
      const temparray4: any[] = [...payloadSlocDesc]
      const temparray5: any[] = [...payloadType]
      const temparray6: any[] = [...payloadDesc]
      const temparray7: any[] = [...payloadMaterial]
      const temparray8: any[] = [...payloadName]
      const temparray9: any[] = [...payloadSpec]
      const temparray10: any[] = [...payloadQuantum]
      const temparray11: any[] = [...payloadHarga]
      const tempUnits: any[] = [...payloadUnit]

      temparray[tempIndex] = plant
      temparray2[tempIndex] = plantDesc
      temparray3[tempIndex] = slocId
      temparray4[tempIndex] = sloc
      temparray5[tempIndex] = matgroup
      temparray6[tempIndex] = matgroupdesc
      temparray7[tempIndex] = matNumber
      temparray8[tempIndex] = matDesc
      temparray9[tempIndex] = spec
      temparray10[tempIndex] = quantumEdit || 0
      temparray11[tempIndex] = tempPrice
      tempUnits[tempIndex] = matUnit

      let _signingConfig = signingPayload
      _signingConfig.total_quantum = temparray10.reduce((prev, curr) => prev + curr, 0)
      setSigningPaylod(_signingConfig)
      loadSigningConfig()

      setPayloadPlantID(temparray)
      setPayloadPlantDesc(temparray2)
      setPayloadSloc(temparray3)
      setPayloadSlocDesc(temparray4)
      setPayloadType(temparray5)
      setPayloadDesc(temparray6)
      setPayloadMaterial(temparray7)
      setPayloadName(temparray8)
      setPayloadSpec(temparray9)
      setPayloadQuantum(temparray10)
      setPayloadHarga(temparray11)
      setPayloadUnit(tempUnits)

      dispatch(putOrderItem(orderItem as TOrderItemContract))

      editSave == 'true' ? setEditSave('false') : setEditSave('true')

      handleClose3()
      swal({
        title: `${t('Item updated')}`,
        icon: 'success',
      })
      setPlanttt('')
      setSalesOption('')
    } else {
      swal({
        title: mandatory,
        icon: 'error',
      })
    }
  }

  // CustomUseEffect(() => {
  //   if (addedProduct.length < 1) {
  //     setCusName('')
  //     setPerihal('')
  //     setCustomerCode('')
  //     setCustomerAddress('')
  //     setSipNumber('')
  //     const inco = document.getElementById('inco') as HTMLSelectElement
  //     if (inco != null) inco.selectedIndex = 0
  //     const inco2 = document.getElementById('inco2') as HTMLInputElement
  //     if (inco2 != null) inco2.value = ''
  //     const assName = document.getElementById('assignerName') as HTMLInputElement
  //     if (assName != null) assName.value = ''
  //     const assPos = document.getElementById('assignerPos') as HTMLInputElement
  //     if (assPos != null) assPos.value = ''
  //     const dateFrom = document.getElementById('date') as HTMLInputElement
  //     if (dateFrom != null) dateFrom.value = ''
  //     const dateTo = document.getElementById('datee') as HTMLInputElement
  //     if (dateTo != null) dateTo.value = ''
  //   }
  // }, [addedProduct])

  CustomUseEffect(() => {
    // const inco = document.getElementById('inco') as HTMLSelectElement
    // if (inco != null) inco.selectedIndex = 1
    // const inco2 = document.getElementById('inco2') as HTMLInputElement
    // if (inco2 != null) inco2.value = ''
    // const assName = document.getElementById('assignerName') as HTMLInputElement
    // if (assName != null) assName.value = ''
    // const assPos = document.getElementById('assignerPos') as HTMLInputElement
    // if (assPos != null) assPos.value = ''
    // const dateFrom = document.getElementById('date') as HTMLInputElement
    // if (dateFrom != null) dateFrom.value = ''
    // const dateTo = document.getElementById('datee') as HTMLInputElement
    // if (dateTo != null) dateTo.value = ''
  }, [showNum])

  // how to remove all item in setAddedProduct
  const handleRemoveAll = () => {
    setAddedProduct([])
    setPayloadPlantID([])
    setPayloadPlantDesc([])
    setPayloadSloc([])
    setPayloadSlocDesc([])
    setPayloadType([])
    setPayloadDesc([])
    setPayloadMaterial([])
    setPayloadUnit([])
    setPayloadName([])
    setPayloadSpec([])
    setPayloadQuantum([])
    setPayloadHarga([])
    setCustomerr('')
    setCustomerrName('')
  }

  const removeSubOrder = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temp: any = [...orderSubDetail]
        const temp2: any = [...addedProduct]
        const temparray: any[] = [...payloadPlantID]
        const temparray2: any[] = [...payloadPlantDesc]
        const temparray3: any[] = [...payloadSloc]
        const temparray4: any[] = [...payloadSlocDesc]
        const temparray5: any[] = [...payloadType]
        const temparray6: any[] = [...payloadDesc]
        const temparray7: any[] = [...payloadMaterial]
        const temparray8: any[] = [...payloadName]
        const temparray9: any[] = [...payloadSpec]
        const temparray10: any[] = [...payloadQuantum]
        const temparray11: any[] = [...payloadHarga]
        const temparray12: any[] = [...payloadCity]
        const temparray13: any[] = [...payloadProvince]
        const temparray14: any[] = [...payloadEndUser]
        const temparray15: any[] = [...payloadNotes]
        const temparray16: any[] = [...payloadPayNotes]
        const temparray17: any[] = [...payloadSeg]
        const temparray18: any[] = [...payloadSegDesc]
        const temparray19: any[] = [...payloadShipping]
        const temparray20: any[] = [...payloadInclude]
        const temparray21: any[] = [...payloadEndUserId]
        const tempUnits: any[] = [...payloadUnit]

        temp.splice(index, 1)
        temp2.splice(index, 1)
        temparray.splice(index, 1)
        temparray2.splice(index, 1)
        temparray3.splice(index, 1)
        temparray4.splice(index, 1)
        temparray5.splice(index, 1)
        temparray6.splice(index, 1)
        temparray7.splice(index, 1)
        temparray8.splice(index, 1)
        temparray9.splice(index, 1)
        temparray10.splice(index, 1)
        temparray11.splice(index, 1)
        temparray12.splice(index, 1)
        temparray13.splice(index, 1)
        temparray14.splice(index, 1)
        temparray15.splice(index, 1)
        temparray16.splice(index, 1)
        temparray17.splice(index, 1)
        temparray18.splice(index, 1)
        temparray19.splice(index, 1)
        temparray20.splice(index, 1)
        temparray21.splice(index, 1)
        tempUnits.splice(index, 1)

        setorderSubDetail(temp)
        setAddedProduct(temp2)
        setPayloadPlantID(temparray)
        setPayloadPlantDesc(temparray2)
        setPayloadSloc(temparray3)
        setPayloadSlocDesc(temparray4)
        setPayloadType(temparray5)
        setPayloadDesc(temparray6)
        setPayloadMaterial(temparray7)
        setPayloadUnit(tempUnits)
        setPayloadName(temparray8)
        setPayloadSpec(temparray9)
        setPayloadQuantum(temparray10)
        setPayloadHarga(temparray11)
        setPayloadCity(temparray12)
        setPayloadProvince(temparray13)
        setPayloadEndUser(temparray14)
        setPayloadNotes(temparray15)
        setPayloadPayNotes(temparray16)
        setPayloadSeg(temparray17)
        setPayloadSegDesc(temparray18)
        setPayloadShipping(temparray19)
        setPayloadInclude(temparray20)
        setPayloadEndUserId(temparray21)
        if (deletee == 'false') {
          SetDeletee('true')
        } else {
          SetDeletee('false')
        }
        setPlantt('')
        setPlant('')
        setPlantDesc('')
        setSloc('')
        setslocId('')

        let _signingConfig = signingPayload
        _signingConfig.total_quantum = temparray10.reduce((prev, curr) => prev + curr, 0)
        console.log(_signingConfig)
        setSigningPaylod(_signingConfig)
        loadSigningConfig()

        dispatch(delOrderItem(index))
        swal({
          title: `${t('deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  const removeSubOrderId = (data: any, index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        dispatch(delOrderItem(index))

        const tempData: any = [...addedProduct]
        const tempItem: any = [...tempItems]

        tempData.splice(index, 1)
        setAddedProduct(tempData)
        tempItem.push(data)
        setTempItems(tempItem)
        setShow7(false)

        const tempId: any = [...payloadID]
        const temp: any = [...orderSubDetail]
        const temp2: any = [...addedProduct]
        const temparray: any[] = [...payloadPlantID]
        const temparray2: any[] = [...payloadPlantDesc]
        const temparray3: any[] = [...payloadSloc]
        const temparray4: any[] = [...payloadSlocDesc]
        const temparray5: any[] = [...payloadType]
        const temparray6: any[] = [...payloadDesc]
        const temparray7: any[] = [...payloadMaterial]
        const temparray8: any[] = [...payloadName]
        const temparray9: any[] = [...payloadSpec]
        const temparray10: any[] = [...payloadQuantum]
        const temparray11: any[] = [...payloadHarga]
        const temparray12: any[] = [...payloadCity]
        const temparray13: any[] = [...payloadProvince]
        const temparray14: any[] = [...payloadEndUser]
        const temparray15: any[] = [...payloadNotes]
        const temparray16: any[] = [...payloadPayNotes]
        const temparray17: any[] = [...payloadSeg]
        const temparray18: any[] = [...payloadSegDesc]
        const temparray19: any[] = [...payloadShipping]
        const temparray20: any[] = [...payloadInclude]
        const temparray21: any[] = [...payloadEndUserId]
        const tempUnits: any[] = [...payloadUnit]

        tempId.splice(index, 1)
        temp.splice(index, 1)
        temp2.splice(index, 1)
        temparray.splice(index, 1)
        temparray2.splice(index, 1)
        temparray3.splice(index, 1)
        temparray4.splice(index, 1)
        temparray5.splice(index, 1)
        temparray6.splice(index, 1)
        temparray7.splice(index, 1)
        temparray8.splice(index, 1)
        temparray9.splice(index, 1)
        temparray10.splice(index, 1)
        temparray11.splice(index, 1)
        temparray12.splice(index, 1)
        temparray13.splice(index, 1)
        temparray14.splice(index, 1)
        temparray15.splice(index, 1)
        temparray16.splice(index, 1)
        temparray17.splice(index, 1)
        temparray18.splice(index, 1)
        temparray19.splice(index, 1)
        temparray20.splice(index, 1)
        temparray21.splice(index, 1)
        tempUnits.splice(index, 1)

        setPayloadID(tempId)
        setorderSubDetail(temp)
        setAddedProduct(temp2)
        setPayloadPlantID(temparray)
        setPayloadPlantDesc(temparray2)
        setPayloadSloc(temparray3)
        setPayloadSlocDesc(temparray4)
        setPayloadType(temparray5)
        setPayloadDesc(temparray6)
        setPayloadMaterial(temparray7)
        setPayloadUnit(tempUnits)
        setPayloadName(temparray8)
        setPayloadSpec(temparray9)
        setPayloadQuantum(temparray10)
        setPayloadHarga(temparray11)
        setPayloadCity(temparray12)
        setPayloadProvince(temparray13)
        setPayloadEndUser(temparray14)
        setPayloadNotes(temparray15)
        setPayloadPayNotes(temparray16)
        setPayloadSeg(temparray17)
        setPayloadSegDesc(temparray18)
        setPayloadShipping(temparray19)
        setPayloadInclude(temparray20)
        setPayloadEndUserId(temparray21)
        if (deletee == 'false') {
          SetDeletee('true')
        } else {
          SetDeletee('false')
        }
        setPlantt('')
        setPlant('')
        setPlantDesc('')
        setSloc('')
        setslocId('')

        let _signingConfig = signingPayload
        _signingConfig.total_quantum = temparray10.reduce((prev, curr) => prev + curr, 0)
        console.log(_signingConfig)
        setSigningPaylod(_signingConfig)
        loadSigningConfig()
        
        swal({
          title: `${t('deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  const [sector, setSector] = useState('')
  const [plantt, setPlantt] = useState('')
  const [planttt, setPlanttt] = useState('')
  const [SectorIDS, setSectorIDS] = useState(localStorage.getItem('sector_ids'))

  // how to SectorIDS split by comma and push to array

  const [titlee, setTitlee] = useState('')
  const [customer_pic_namee, setCustomer_pic_namee] = useState('')
  const [customer_pic_positionn, setCustomer_pic_positionn] = useState('')
  const [terms_and_conditionss, setTerms_and_conditionss] = useState('')
  const [mail_bodyy, setMail_bodyy] = useState('Bersama ini kami sampaikan persetujuan pembelian dengan rincian sebagai berikut:')
  const [customer_attnn, setCustomer_attnn] = useState('')
  const [port_of_dischargee, setPort_of_dischargee] = useState('')
  const [lain_lainn, setLain_lainn] = useState('')
  const [keterangannn, setKeterangannn] = useState('')
  const [textPenutupp, setTextPenutupp] = useState('')

  const [titleeEn, setTitleeEn] = useState('')
  const [mail_bodyyEn, setMail_bodyyEn] = useState('We hereby convey the purchase agreement with the following details:')
  const [customer_attnnEn, setCustomer_attnnEn] = useState('')
  const [textPenutuppEn, setTextPenutuppEn] = useState('')
  const [lain_lainnEn, setLain_lainnEn] = useState('')
  const [keterangannnEn, setKeterangannnEn] = useState('')
  const [terms_and_conditionssEn, setTerms_and_conditionssEn] = useState('')

  const handleSaveTitle = () => {
    setTitlee(title)
    let close = document.getElementById('targetJudul') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('Judul')}`,
      icon: 'success',
    })
  }

  const handleSaveName = () => {
    setCustomer_pic_namee(customer_pic_name)
    let close = document.getElementById('targetnama') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('nama')}`,
      icon: 'success',
    })
  }

  const handleSavePosition = () => {
    setCustomer_pic_positionn(customer_pic_position)
    let close = document.getElementById('targetPosition') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('Position')}`,
      icon: 'success',
    })
  }

  const handleSaveSyarat = () => {
    setTerms_and_conditionss(terms_and_conditions)
    let close = document.getElementById('targetterms_and_conditions') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('terms_and_conditions')}`,
      icon: 'success',
    })
  }

  const handleSaveMail = () => {
    setMail_bodyy(mail_body)
    let close = document.getElementById('targetmail_body') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('mail_body')}`,
      icon: 'success',
    })
  }

  const handleSaveAttn = () => {
    setCustomer_attnn(customer_attn)
    let close = document.getElementById('targetcustomer_attn') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('customer_attn')}`,
      icon: 'success',
    })
  }

  const handleSavePort = () => {
    setPort_of_dischargee(port_of_discharge)
    let close = document.getElementById('targetport_of_discharge') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('port_of_discharge')}`,
      icon: 'success',
    })
  }

  const handleSaveOther = () => {
    setLain_lainn(lain_lain)
    let close = document.getElementById('targetother') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('other')}`,
      icon: 'success',
    })
  }

  const handleSaveKeterangan = () => {
    setKeterangannn(keterangann)
    let close = document.getElementById('targetorder-keterangan') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('order-keterangan')}`,
      icon: 'success',
    })
  }

  const handleSaveTextPenutup = () => {
    setTextPenutupp(textPenutup)
    let close = document.getElementById('targettextPenutup') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('textPenutup')}`,
      icon: 'success',
    })
  }

  const handleSaveNoExport = () => {
    setNoExportt(noExport)
    let close = document.getElementById('targetnomorIzinExport') as HTMLInputElement

    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t('nomorIzinExport')}`,
      icon: 'success',
    })
  }

  const checkMandatoryy = () => {
    if (enduserDesc == '') return t('isi') + t('End User')
    else if (province == 0) return t('isi') + t('Province')
    else if (city == 0) return t('isi') + t('City')
    else if (
      ptype2 != 'KANTONG/SACK' &&
      (subprice == '' || subprice == 0 || isNaN(parseFloat(subprice)))
    )
      return t('isi') + t('kontrak-harga')
    else if (pnumber == '') return t('isi') + t('Product Name')
    else if (quantum == 0 || quantum == '' || isNaN(quantum))
      return ptype2 != 'KANTONG/SACK' ? t('isi') + t('Quantum') : t('isi') + t('sack')
    else if (sektorid == 1 && segment == '') return t('isi') + t('segment')
    else if (shipping < 0) return t('shipping tolerance tidak boleh minus')
    else if (shipping >= 100) return t('Shipping tolerance melebihi 100%')
    else return 'nothing'
  }

  const insertAddOrder = () => {
    console.log("insert order")
    const mandatoryCheck = checkMandatoryy()
    if (mandatoryCheck == 'nothing') {
      let tempprice = 0
      if (subprice == '' || isNaN(parseFloat(subprice))) tempprice = 0
      else tempprice = parseFloat(subprice)
      let shiping = '0'
      if (shipping == '' || isNaN(parseInt(shipping))) shiping = '0'
      else shiping = shipping
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      let ppn = false
      if (ckbox != null) {
        if (ckbox.checked) ppn = true
        else ppn = false
      }
      const tempOrder = [...addedProduct]
      const temp = {
        sales_org_code: salesOrg,
        sales_org_code_desc: salesOrgDesc,
        incoterm1_id: incotermId,
        incoterm1_desc: incotermIdDesc,
        incoterm2_id: incotermId2Desc,
        is_new: true,
        product_type: ptype,
        product_type_desc: ptype2,
        product_name: pname,
        product_spec: pspec,
        fixed_price: tempprice,
        fixed_quantum: parseFloat(quantum),
        shipping_tolerance: shiping,
        shipping_tolerance_contract: shiping,
        province_id: province,
        province_desc: provinceDesc,
        city_id: city,
        city_desc: cityDesc,
        sector_id: sektorid,
        end_user: enduserDesc,
        end_user_multiple: sektorid != 1 ? false : !isNoEnduser,
        end_user_id: enduser,
        notes: note,
        material_number: pnumber,
        unit: punit,
        segment_code: segment,
        segment_name: segmentDesc,
        plant: '',
        plant_desc: '',
        sloc: '',
        sloc_description: '',
        payment_type_1: p11,
        payment_type_1_desc: p1,
        payment_type_2: p22,
        payment_type_2_desc: p2,
        payment_notes: keterangan,
        quantity: parseFloat(quantum),
        include_ppn: ppn,
        schedules: [],
        attachments: [],
      }
      tempOrder.push(temp)
      setAddedProduct(tempOrder)
      dispatch(setOrderItems(tempOrder as TOrderItemContract[]))

      payloadType.push(ptype)
      payloadDesc.push(ptype2)
      payloadName.push(pname)
      payloadSpec.push(pspec)
      payloadHarga.push(tempprice)
      payloadQuantum.push(parseFloat(quantum))
      payloadCity.push(city)
      payloadProvince.push(province)
      payloadEndUser.push(enduserDesc)
      payloadEndUserId.push(enduser)
      payloadNotes.push(note)
      payloadPayNotes.push(keterangan)
      payloadSeg.push(segment)
      payloadSegDesc.push(segmentDesc)
      payloadShipping.push(shiping)
      payloadInclude.push(ppn)

      setTotalQ(payloadQuantum.reduce((a: any, b: any) => a + b, 0))

      let _tempQuantum = tempOrder.reduce(
          (a: any, b: any) =>
            b.product_type != '8105' ? a + (b.fixed_quantum - (b.quantum_contract || 0)) : a + 0,
          0
      )

      let _signingConfig = signingPayload
      _signingConfig.total_quantum = _tempQuantum
      setSigningPaylod(_signingConfig)
      loadSigningConfig()

      setQuantumApprove(_tempQuantum)

      setKantongApprove(
        tempOrder.reduce(
          (a: any, b: any) =>
            b.product_type == '8105' ? a + (b.fixed_quantum - (b.quantum_contract || 0)) : a + 0,
          0
        )
      )

      let totalBeforePPN = 0
      for (let i = 0; i < payloadHarga.length; i++) {
        totalBeforePPN += payloadHarga[i] * payloadQuantum[i]
      }
      setBeforePpn(totalBeforePPN)

      let totalPPN = 0
      for (let i = 0; i < payloadHarga.length; i++) {
        totalPPN +=
          payloadHarga[i] * payloadQuantum[i] +
          ((payloadHarga[i] * payloadQuantum[i]) / 100) * tempOrder[0].ppn -
          ((payloadHarga[i] * payloadQuantum[i] +
            ((payloadHarga[i] * payloadQuantum[i]) / 100) * tempOrder[0].ppn) /
            ((tempOrder[0].ppn + 100) / 100) /
            100) *
            0
      }
      if (totalBeforePPN >= 10000000) {
        setFixedPrice(totalPPN - totalBeforePPN * (payloadPPH22 / 100))
      } else {
        setFixedPrice(totalPPN)
      }

      setShow4(false)
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const clearState = () => {
    setDisableCKBOX(false)
    setEnduser('')
    setEnduserDesc('')
    setProvince(0)
    setCity(0)
    setPtype('')
    setPtype2('')
    setFullProductName([])
    setPname('')
    setPnumber('')
    setPspec('')
    setSegment('')
    setSegmentDesc('')
    setSubprice(0)
    setQuantum(0)
    setPay1('')
    setPay2('')
    setketerangan('')
    setEnduserArray([])
  }

  const handleAddProduct = () => {
    clearState()
    setShow4(true)
  }

  CustomUseEffect(() => {
    let totalQ = payloadQuantum.reduce((a: any, b: any) => a + b, 0)
    setTotalQ(totalQ)

    let totalQuantum = payloadQuantum.reduce((acc, curr, index) => {
      return payloadType[index] != '8105' ? acc + curr : acc + 0
    }, 0)
    setQuantumApprove(totalQuantum)

    let totalKantong = payloadQuantum.reduce((acc, curr, index) => {
      return payloadType[index] == '8105' ? acc + curr : acc + 0
    }, 0)
    setKantongApprove(totalKantong)

    let totalBeforePPN = 0
    for (let i = 0; i < payloadHarga.length; i++) {
      totalBeforePPN += payloadHarga[i] * payloadQuantum[i]
    }
    setBeforePpn(totalBeforePPN)

    let totalPPN = 0
    for (let i = 0; i < payloadHarga.length; i++) {
      totalPPN +=
        payloadHarga[i] * payloadQuantum[i] +
        ((payloadHarga[i] * payloadQuantum[i]) / 100) * ppn -
        ((payloadHarga[i] * payloadQuantum[i] +
          ((payloadHarga[i] * payloadQuantum[i]) / 100) * ppn) /
          ((ppn + 100) / 100) /
          100) *
          0
    }
    if (totalBeforePPN >= 10000000) {
      setFixedPrice(totalPPN - totalBeforePPN * (payloadPPH22 / 100))
    } else {
      setFixedPrice(totalPPN)
    }
  }, [editSave, deletee])

  const fieldClear = () => {
    setFullProductName([])
  }

  const fieldClearer = (status: any) => {
    if (status > 0) {
      const hargap = document.getElementById('hargap') as HTMLInputElement
      if (hargap != null) hargap!.value = ''
      setSubprice(0)
      const kuantum = document.getElementById('kuantum') as HTMLInputElement
      if (kuantum != null) kuantum!.value = ''
      setQuantum(0)
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      if (ckbox != null) ckbox.checked = false
      const shipping = document.getElementById('shipping') as HTMLInputElement
      if (shipping != null) shipping!.value = ''
      setShipping(0)
      if (status > 1) {
        setPname('')
        setPnumber('')
        setFullProductName([])
        if (status > 2) {
          const jenis = document.getElementById('jenis') as HTMLSelectElement
          if (jenis != null) jenis!.selectedIndex = 0
          setPtype('')
          setPtype2('')
          if (status > 3) {
            if (status > 4) {
              setCity(0)
              setCityDesc('')
            }
          }
        }
      }
    }
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  useEffect(() => {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }
    getAccessMenu()
    handleYear()
  }, [])

  const [submitOrder, setSubmitOrder] = useState<any[]>([])
  const [submitDesc, setSubmitDesc] = useState<any[]>([])
  const [schedules, setSchedules] = useState<any[]>([])
  const [listNonSales, setListNonSales] = useState<any[]>([])
  const [nonpenjualan, setNonPenjualan] = useState('')
  const [nonPenjualanFlag, setNonPenjualanFlag] = useState('')
  const [SubID, setSubID] = useState(0)
  const [key, setKey] = useState<any>(0)

  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [editedIndex, setEditedIndex] = useState<any>()

  const hapusSchedule = (index: any) => {
    const tempOrder: any[] = addedProduct
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let temp: any[] = allJadwal
        temp.splice(index, 1)
        let tempOrder_ = addedProduct.map((item: any, idx) => {
          return idx == index2 ? {... item, schedules: temp} : item
        })
        setEditedIndex(null)
        const temptaking = taking - 1
        setTaking(temptaking)
        setAllJadwal(temp)
        setSubmitOrder(tempOrder_)
        setAddedProduct(tempOrder_)
        setTempTanggal(0)
        setTempBulan(0)
        setTempTon(0)
        setTempTahun(0)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  const rubahSchedule = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    const tempOrder = addedProduct
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (tempOrder[index2]?.fixed_quantum >= tempoquantum - tonlama + tempTon) {

            let temp: any[] = (allJadwal || []).map((item: any, idx) => {
              return idx == index ? {
                ... item,
                tonnage
              } : item
            })

            let tempOrder_ = addedProduct.map((item: any, idx) => {
              return idx == index2 ? {
                ... item,
                schedules: temp
              } : item
            })

            setSubmitOrder(tempOrder_)
            setAddedProduct(tempOrder_)
            setEditedIndex(null)
            setAllJadwal(temp)
            
            swal({
              title: `${t('jadwalBerhasilDiEdit')}`,
              icon: 'success',
            })

          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const clearInputJadwal = () => {
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    if(input4){
      input4.value = ''
    }
  }

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
    setEditedIndex(null)
  }

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const checktaking = () => {
    let temp: any[] = tempData?.schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'

    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  const sendJadwal = () => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })

    const checkMandatory = validasiJadwal()
    const CheckTaking = checktaking()
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (parseFloat(fixedQuantum) >= tempoquantum + tempTon) {
          let temp: any[] = allJadwal || tempData?.schedules
          let sort = temp.length

          const tempobject = {
            sort: sort + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }

          if (temp == null) {
            const temp2 = []
            temp2.push(tempobject)
            temp = temp2
          } else {
            temp = [... temp, tempobject]
          }
          const temptaking = taking + 1
          setTaking(temptaking)
          let tempOrder = addedProduct.map((item: any, idx) => {
            return idx == index2 ? {
              ... item,
              schedules: temp
            } : item
          })

          setAllJadwal(temp)
          setSubmitOrder(tempOrder)
          setAddedProduct(tempOrder)

          // setShowJadwal(false)
          if (key == 0) {
            setKey(1)
          } else {
            setKey(0)
          }
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  CustomUseEffect(() => {
    const input1 = document.getElementById('jadwalminggu1') as HTMLSelectElement
    if (input1 != null) input1.selectedIndex = 0
    const input2 = document.getElementById('jadwalbulan1') as HTMLSelectElement
    if (input2 != null) input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun1') as HTMLSelectElement
    if (input3 != null) input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    const input5 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    if (input5 != null) input5.selectedIndex = 0
    if(input4) input4.value = ''
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
    setEditedIndex(null)
  }, [allJadwal])

  const handleJadwal = (item: any) => {
    setTempData(item)
    setAllJadwal(item?.schedules)

    if (item?.schedules?.length == undefined) {
      setTaking(0)
    } else {
      setTaking(item?.schedules?.length)
    }

    setShowJadwal1(true)
  }

  const [uploadType, setUploadType] = useState('')
  const [orderItemFiles, setOrderItemsFiles] = useState<any[]>([])
  const [filess, setFiless] = useState<any>('')
  const [fileHeader, setFileHeader] = useState<any[]>([])

  const handleDeleteUploadHeader = (
    index: any,
    data: any,
    setData: any,
    type: any,
    datafull: any,
    setdatafull: any
  ) => {
    if (type == 'header') {
      // const tempArray = [...data]
      // tempArray.splice(index, 1)
      // setData(tempArray)
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            tempArray.splice(index, 1)
            setData(tempArray)
            swal({
              closeOnClickOutside: false,
              title: t('deleted successfully'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    } else {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            const tempfull = datafull
            tempArray?.splice(index, 1)
            tempfull.attachments = tempArray
            setData(tempArray)
            setdatafull(tempfull)
            swal({
              closeOnClickOutside: false,
              title: t('deleted successfully'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    }
  }

  const validasiFile = () => {
    if (filess == null || filess == '') return 'File'
    // else if (namaFile == '' && idSektor == 2)
    //   return 'File Name'
    else if (description == '') return 'File Information'
    // else if (dataType == '' && idSektor == 2)
    //   return 'Data Type'
    else return 'nothing'
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiless('')
    setNamaFile('')
    setTempRole([])
    setIsPrivate(false)
    setDescription('')
    setDataType('')
  }

  const handleUploadOrderItem = (item: any) => {
    setTempData(item)
    setOrderItemsFiles(item?.attachments)
    setUploadType('order-item')
    setShow6(true)
  }

  const handleUpload2 = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: filess,
        name: namaFile,
        description: description,
        file_type: dataType,
        roles: temparray,
        private: isPrivate.toString(),
      }
      let tempArray = [...addedProduct]
      let temp: any[] = tempData?.attachments
      if (temp == null) {
        const temp2 = []
        temp2.push(tempObject)
        temp = temp2
      } else {
        temp.push(tempObject)
      }
      if (key == 0) {
        setKey(1)
      } else {
        setKey(0)
      }
      // tempArray.push(tempObject);
      tempArray[index3].attachments = temp

      setSubmitOrder(tempArray)
      // setShow1(false)
      setFiless('')
      setNamaFile('')
      setDescription('')
      setDataType('')
      setIsPrivate(false)
      setTempRole([])
      clearFile()
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const [indexItem, setIndexItem] = useState<any[]>([])

  const onclickCheckBox = (index: any) => {
    const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement
    const tempArray: any[] = indexItem
    if (isChecked.checked) {
      tempArray.push(isChecked.value)!
      setIndexItem(tempArray)
    } else {
      const tempindex = tempArray.indexOf(isChecked.value)!
      tempArray.splice(tempindex, 1)
      setIndexItem(tempArray)
    }
  }

  const addInOrder = (type: any) => {
    const tempArray = [...tempItems]
    const tempArray2 = [...addedProduct]
    let _tempQuantum = 0;
    if (type == 'all') {
      tempArray.map((item: any, index: any) => {
        tempArray2.push({
          ...item,
          shipping_tolerance_contract: item.shipping_tolerance
        })

        if(!incoterm){
          setIncoterm(item?.incoterm1_id)
        }
        if(!incoterm2){
          let _inc2 = (item?.incoterm2?.code || item?.incoterm2_id)
          setIncoterm2(
            _inc2 && _inc2 != "0" ? _inc2 : null
          )
        }
      })
      dispatch(setOrderItems(tempArray2))

      setAddedProduct(tempArray2)
      _tempQuantum = tempArray2.reduce(
          (a: any, b: any) => (b.product_type != '8105' ? a + (b.fixed_quantum || 0) : a + 0),
          0
      )
      setQuantumApprove(_tempQuantum)

      setKantongApprove(
        tempArray2.reduce(
          (a: any, b: any) => (b.product_type == '8105' ? a + (b.fixed_quantum || 0) : a + 0),
          0
        )
      )

      let beforeppn = tempArray2.reduce((a: any, b: any) => a + (b['price_before_ppn'] || 0), 0)
      setBeforePpn(beforeppn)

      let totalPrice = tempArray2.reduce((a: any, b: any) => a + (b['price_after_ppn'] || 0), 0)
      if (beforeppn >= 10000000) {
        setFixedPrice(totalPrice - beforeppn * (tempArray2[0]?.pph22 / 100))
      } else {
        setFixedPrice(totalPrice)
      }

      setP1(tempArray2[0]?.payment_type_1_desc)
      setP11(tempArray2[0]?.payment_type_1)
      setP2(tempArray2[0]?.payment_type_2_desc)
      setP22(tempArray2[0]?.payment_type_2)
      const tempPlant: string[] = []
      tempArray2?.forEach((data: any) => {
        tempPlant.push(data.plant_desc)
      })
      setPayloadPlantDesc(tempPlant)

      const tempID: string[] = []
      tempArray2?.forEach((data: any) => {
        tempID.push(data?.id)
      })
      setPayloadID(tempID)

      const tempPlantD: string[] = []
      tempArray2?.forEach((data: any) => {
        tempPlantD.push(data?.plant)
      })
      setPayloadPlantID(tempPlantD)

      const tempSlacId: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSlacId.push(data?.sloc)
      })
      setPayloadSloc(tempSlacId)

      const tempSlac: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSlac.push(data?.sloc_description)
      })
      setPayloadSlocDesc(tempSlac)

      const tempProductType: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProductType.push(data?.product_type)
      })
      setPayloadType(tempProductType)

      const tempProductDesc: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProductDesc.push(data?.product_type_desc)
      })
      setPayloadDesc(tempProductDesc)

      const tempProductName: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProductName.push(data?.product_name)
      })
      setPayloadName(tempProductName)

      const tempMaterial: string[] = []
      tempArray2?.forEach((data: any) => {
        tempMaterial.push(data?.material_number)
      })
      setPayloadMaterial(tempMaterial)

      const tempUnits: string[] = []
      tempArray2?.forEach((data: any) => {
        tempUnits.push(data?.unit)
      })
      setPayloadUnit(tempUnits)

      const tempSpec: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSpec.push(data?.product_spec)
      })
      setPayloadSpec(tempSpec)

      const tempQuantum: number[] = []
      tempArray2?.forEach((data: any) => {
        tempQuantum.push(parseFloat(data?.fixed_quantum) - parseFloat(data?.quantum_contract))
      })
      setPayloadQuantum(tempQuantum)
      setTotalQ(tempQuantum.reduce((a: any, b: any) => a + b, 0))

      let subIds: any = []
      tempArray2.forEach((sub: any) => {
        subIds.push(sub?.id)
      })
      setorderSubDetail(subIds)

      let totalquantum = tempArray2.reduce((a: any, b: any) => a + (b['fixed_price'] || 0), 0)
      setTotalQuantum(totalquantum)

      const tempHarga: string[] = []
      tempArray2?.forEach((data: any) => {
        tempHarga.push(data?.fixed_price)
      })
      setPayloadHarga(tempHarga)

      const tempEndUser: string[] = []
      tempArray2?.forEach((data: any) => {
        tempEndUser.push(data?.end_user_detail?.name || data?.end_user)
      })
      setPayloadEndUser(tempEndUser)

      const tempEndUserId: string[] = []
      tempArray2?.forEach((data: any) => {
        tempEndUserId.push(data?.end_user_detail?.end_user_code || data?.end_user)
      })
      setPayloadEndUserId(tempEndUserId)

      const tempNotes: string[] = []
      tempArray2?.forEach((data: any) => {
        tempNotes.push(data?.notes)
      })
      setPayloadNotes(tempNotes)

      const tempPayNotes: string[] = []
      tempArray2?.forEach((data: any) => {
        tempPayNotes.push(data?.payment_note)
      })
      setPayloadPayNotes(tempPayNotes)

      const tempSeg: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSeg.push(data?.segment_code)
      })
      setPayloadSeg(tempSeg)

      const tempSegDesc: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSegDesc.push(data?.segment_name)
      })
      setPayloadSegDesc(tempSegDesc)

      const tempShipping: string[] = []
      tempArray2?.forEach((data: any) => {
        tempShipping.push(data?.shipping_tolerance)
      })
      setPayloadShipping(tempShipping)

      const tempInclude: string[] = []
      tempArray2?.forEach((data: any) => {
        tempInclude.push(data?.include_ppn)
      })
      setPayloadInclude(tempInclude)

      const tempCity: string[] = []
      tempArray2?.forEach((data: any) => {
        tempCity.push(data?.city_id)
      })
      setPayloadCity(tempCity)

      const tempProvince: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProvince.push(data?.province.id || data?.province_id)
      })
      setPayloadProvince(tempProvince)

      setTempItems([])
    } else {
      indexItem.map((item: any, index: any) => {
        console.log(tempArray[item])
        tempArray2.push({
          ...tempArray[item],
          shipping_tolerance_contract: tempArray[item].shipping_tolerance
        })

        if(!incoterm){
          setIncoterm(tempArray[item].incoterm1_id)
        }
        if(!incoterm2){
          let _inc2 = tempArray[item].incoterm2?.code || tempArray[item].incoterm2_id
          setIncoterm2(
            _inc2 && _inc2 != "0" ? _inc2 : null
          )
        }
      })

      dispatch(setOrderItems(tempArray2))

      if (tempArray.length == indexItem.length) {
        setTempItems([])
      } else {
        indexItem.map((item: any, index: any) => {
          tempArray.splice(item, 1)
        })
        setTempItems(tempArray)
        // tempArray.splice(indexItem[0], indexItem.length)
        // setTempItems(tempArray)
      }

      // indexItem.map((item: any, index: any) => {
      //   tempArray.splice(item, 1)
      // })
      // setTempItems(tempArray)

      _tempQuantum =
        tempArray2.reduce(
          (a: any, b: any) =>
            b.product_type != '8105' ? a + (b.fixed_quantum - b.quantum_contract || 0) : a + 0,
          0
        )
      setQuantumApprove(_tempQuantum)

      setKantongApprove(
        tempArray2.reduce(
          (a: any, b: any) => (b.product_type == '8105' ? a + (b.fixed_quantum || 0) : a + 0),
          0
        )
      )
      let beforeppn = tempArray2.reduce((a: any, b: any) => a + (b['price_before_ppn'] || 0), 0)
      setBeforePpn(beforeppn)

      let totalPrice = tempArray2.reduce((a: any, b: any) => a + (b['price_after_ppn'] || 0), 0)
      if (beforeppn >= 10000000) {
        setFixedPrice(totalPrice - beforeppn * (tempArray2[0]?.pph22 / 100))
      } else {
        setFixedPrice(totalPrice)
      }

      setP1(tempArray2[0]?.payment_type_1_desc)
      setP11(tempArray2[0]?.payment_type_1)
      setP2(tempArray2[0]?.payment_type_2_desc)
      setP22(tempArray2[0]?.payment_type_2)
      const tempPlant: string[] = []
      tempArray2?.forEach((data: any) => {
        tempPlant.push(data.plant_desc)
      })
      setPayloadPlantDesc(tempPlant)

      const tempID: string[] = []
      tempArray2?.forEach((data: any) => {
        tempID.push(data?.id)
      })
      setPayloadID(tempID)

      const tempPlantD: string[] = []
      tempArray2?.forEach((data: any) => {
        tempPlantD.push(data?.plant)
      })
      setPayloadPlantID(tempPlantD)

      const tempSlacId: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSlacId.push(data?.sloc)
      })
      setPayloadSloc(tempSlacId)

      const tempSlac: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSlac.push(data?.sloc_description)
      })
      setPayloadSlocDesc(tempSlac)

      const tempProductType: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProductType.push(data?.product_type)
      })
      setPayloadType(tempProductType)

      const tempProductDesc: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProductDesc.push(data?.product_type_desc)
      })
      setPayloadDesc(tempProductDesc)

      const tempProductName: string[] = []
      tempArray2?.forEach((data: any) => {
        tempProductName.push(data?.product_name)
      })
      setPayloadName(tempProductName)

      const tempMaterial: string[] = []
      tempArray2?.forEach((data: any) => {
        tempMaterial.push(data?.material_number)
      })
      setPayloadMaterial(tempMaterial)

      const tempUnits: string[] = []
      tempArray2?.forEach((data: any) => {
        tempUnits.push(data?.unit)
      })
      setPayloadUnit(tempUnits)

      const tempSpec: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSpec.push(data?.product_spec)
      })
      setPayloadSpec(tempSpec)

      const tempQuantum: number[] = []
      tempArray2?.forEach((data: any) => {
        tempQuantum.push(parseFloat(data?.fixed_quantum) - parseFloat(data?.quantum_contract))
      })
      setPayloadQuantum(tempQuantum)
      setTotalQ(tempQuantum.reduce((a: any, b: any) => a + b, 0))

      let subIds: any = []
      tempArray2.forEach((sub: any) => {
        subIds.push(sub?.id)
      })
      setorderSubDetail(subIds)

      let totalquantum = tempArray2.reduce((a: any, b: any) => a + (b['fixed_price'] || 0), 0)
      setTotalQuantum(totalquantum)

      const tempHarga: string[] = []
      tempArray2?.forEach((data: any) => {
        tempHarga.push(data?.fixed_price)
      })
      setPayloadHarga(tempHarga)

      const tempEndUser: string[] = []
      tempArray2?.forEach((data: any) => {
        tempEndUser.push(data?.end_user_detail?.name || data?.end_user)
      })
      setPayloadEndUser(tempEndUser)

      const tempEndUserId: string[] = []
      tempArray2?.forEach((data: any) => {
        tempEndUserId.push(data?.end_user_detail?.end_user_code || data?.end_user)
      })
      setPayloadEndUserId(tempEndUserId)

      const tempNotes: string[] = []
      tempArray2?.forEach((data: any) => {
        tempNotes.push(data?.notes)
      })
      setPayloadNotes(tempNotes)

      const tempPayNotes: string[] = []
      tempArray2?.forEach((data: any) => {
        tempPayNotes.push(data?.payment_note)
      })
      setPayloadPayNotes(tempPayNotes)

      const tempSeg: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSeg.push(data?.segment_code)
      })
      setPayloadSeg(tempSeg)

      const tempSegDesc: string[] = []
      tempArray2?.forEach((data: any) => {
        tempSegDesc.push(data?.segment_name)
      })
      setPayloadSegDesc(tempSegDesc)

      const tempShipping: string[] = []
      tempArray2?.forEach((data: any) => {
        tempShipping.push(data?.shipping_tolerance)
      })
      setPayloadShipping(tempShipping)

      const tempInclude: string[] = []
      tempArray2?.forEach((data: any) => {
        tempInclude.push(data?.include_ppn)
      })
      setPayloadInclude(tempInclude)

      if (sektorid != 3) {
        const tempCity: string[] = []
        tempArray2?.forEach((data: any) => {
          tempCity.push(data?.city_id)
        })
        setPayloadCity(tempCity)

        const tempProvince: string[] = []
        tempArray2?.forEach((data: any) => {
          tempProvince?.push(data?.province.id || data?.province_id)
        })
        setPayloadProvince(tempProvince)
      }

      setAddedProduct(tempArray2)
      
      
      setShow7(false)
    }

    if(tempArray2.length > 0){
      let _firstProduct = tempArray2[0]
      let _signingConfig = signingPayload
      _signingConfig.sector_id = _firstProduct.sector_id
      _signingConfig.product_type = _firstProduct.product_type
      _signingConfig.sales_org_code = _firstProduct.sales_org_code
      _signingConfig.total_quantum = _tempQuantum
      setSigningPaylod(_signingConfig)

      loadSigningConfig()
    }
  }

  const [includePPN, setIncludePPN] = useState(true)
  useEffect(() => {
    loadSigningConfig()
  }, [salesAreaCode, cityData])

  const [addTextLanguage, setAddTextLanguage] = useState('id')

  const letterData = {
    lang: i18next.language,
    sector: sektorid ? sektorid : '',
    customer: cusTitle ? cusTitle + ' ' + cusName : cusName,
    anper: addedProduct
      ? addedProduct[0]?.produsen?.name || addedProduct[0]?.sales_org_code_desc
      : '',
    address: userDetail ? userDetail.address.street1 : '',
    city: userDetail ? userDetail.city.city_name : '',
    region: userDetail ? userDetail.region.region_name : '',
    customerAttn: i18next.language == 'id' ? customer_attnn : (customer_attnnEn || (customer_attnn || '')),
    mail: i18next.language == 'id' ? mail_bodyy : (mail_bodyyEn || (mail_bodyy || '')),
    terms: i18next.language == 'id' ? terms_and_conditionss : (terms_and_conditionssEn || (terms_and_conditionss || '')),
    title: i18next.language == 'id' ? titlee : (titleeEn || (titlee || '')),
    dateFrom: estimateFrom ? estimateFrom : '',
    dateTo: estimate ? estimate : '',
    port: port_of_dischargee ? port_of_dischargee : '',
    lain_lain: i18next.language == 'id' ? lain_lainn : (lain_lainnEn || (lain_lainn || '')),
    keterangan: i18next.language == 'id' ? keterangannn : (keterangannnEn || (keterangannn || '')),
    textPenutup: i18next.language == 'id' ? textPenutupp : (textPenutuppEn || (textPenutupp || '')),
    footerContentId: footer ? footer.indonesia.content : '',
    footerContentEn: footer ? footer.english.content : '',
    subItem: addedProduct ? addedProduct : [],
    signername: assignerName ? assignerName : '',
    singerposition: assignerPos ? assignerPos : '',
    cusName: customer_pic_namee ? customer_pic_namee : '',
    cusPos: customer_pic_positionn ? customer_pic_positionn : '',
    include: includePPN,
    // include: addedProduct[0]?.include_ppn,
    payloadharga: payloadHarga ? payloadHarga : '',
    payloadquantum: payloadQuantum ? payloadQuantum : '',
    payloadspec: payloadSpec ? payloadSpec : '',
    imgHeader: imgHeader ? imgHeader?.url_file : '',
    imgFooter: imgFooter ? imgFooter?.url_file : '',
    segment:  addedProduct ? addedProduct[0]?.segment_name : '',
    incoterm1: fullIncoterm.find((item: any) => item.value == incoterm)?.label,
    incoterm2: incoterm2,
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleNameFromState(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length)
        temp = temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label
      else
        temp =
          temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label + ', '
    })
    return temp
  }

  const loadSigningConfig = async () => {
    const _signingConfig = signingPayload
    if(salesAreaCode){
      _signingConfig.province_id = salesAreaCode
    }
    if(cityData){
      _signingConfig.city_id = cityData
    }

    if(!salesAreaCode || !cityData) return

    setSigningPaylod(_signingConfig)
    setBtnLoading(true)

    const res = await getForModule(_signingConfig)
      .then((res: any) => {
        const resp = res.data.data
        if (resp) {
          if (!assignerName) {
            setassignerName(resp.signer_name)
          }
          if (!assignerPos) {
            setassignerPos(resp.signer_position)
          }
        }
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page create contract')}</PageTitle>
      <div className='card'>
        <div className='card-body'>
          <Row>
            <Col md={6}>
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('sip-number')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <div className='d-flex'>
                    <Form.Control
                      value={sipNumber ? '11' + sipNumber : ''}
                      className='me-1'
                      size='sm'
                      disabled
                      placeholder={t('sip-number')}
                    />
                    <Button
                      className='btn btn-primary d-flex justify-content-center align-items-center'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('telusuri')}
                      onClick={handleShow2}
                      size='sm'
                    >
                      <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                    </Button>
                    <Modal
                      show={show2}
                      onHide={handleClose2}
                      centered
                      size='lg'
                      backdrop='static'
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('Browse')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {loading ? (
                          <>
                            <Row>
                              <Col lg={3}>
                                <Skeleton height={30} />
                              </Col>
                              <Col lg={3}>
                                <Skeleton height={30} />
                              </Col>
                              <Col lg={3}>
                                <Skeleton height={30} />
                              </Col>
                              <Col lg={3}>
                                <Skeleton height={30} />
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <>
                            <TableBrowseSIP
                              data={sipNum}
                              tooltip={tooltip}
                              paginateNumber={paginateNumber}
                              numberUrls={numberURL}
                              onToggleExpand={handleOpen}
                              onSipSelected={(item) => {
                                localId(item?.id, item?.SIP_number, item?.order_sub_details)
                                dispatch(setOrderItems([]))
                                dispatch(setOrderItem(null))
                              }}
                            />
                          </>
                        )}
                      </Modal.Body>
                    </Modal>
                  </div>
                  {/* <Form.Select
                  aria-label='Default select example'
                  onChange={(e: any) => {
                    localId(e.target.value)
                  }}
                >
                  <option selected></option>
                  {sipNum.map((item, index) => {
                    return <option value={item.id}>{item.SIP_number}</option>
                  })}
                </Form.Select> */}
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    value={customerCode}
                    placeholder={t('Customer Number')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Address')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    as='textarea'
                    value={customerAddress}
                    placeholder={t('Address')}
                    disabled
                    size='sm'
                    style={{height: '40px'}}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>{t('Customer Name')}</p>
                </Col>
                <Col lg={7}>
                  {showNum != null ? (
                    <Form.Control
                      type='text'
                      placeholder={t('Customer Name')}
                      value={cusName}
                      disabled
                      size='sm'
                    />
                  ) : (
                    <Form.Control type='text' placeholder={t('Customer Name')} disabled size='sm' />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    Incoterm<span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Select
                    placeholder='Incoterm'
                    key={cusName}
                    value={fullIncoterm.find((x) => x.value == incoterm)}
                    onChange={(e: any) => setIncoterm(e?.value)}
                    options={fullIncoterm}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    Incoterm 2<span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Form.Control
                    id='inco2'
                    type='text'
                    placeholder='Incoterm 2'
                    value={incoterm2}
                    onChange={(e: any) => setIncoterm2(e.target.value)}
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('negara')}
                    {/* <span className='text-danger'>*</span> */}
                  </p>
                </Col>
                <Col lg={7}>
                  <Select
                    placeholder={t('negara')}
                    key={cusName}
                    onChange={(e: any) => separator(e?.value, setCountryId, setCountryDest)}
                    options={countryList}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('provinsi-tujuan')}
                    {/* <span className='text-danger'>*</span> */}
                  </p>
                </Col>
                <Col lg={7}>
                  <Select
                    placeholder={t('provinsi-tujuan')}
                    key={cusName}
                    isDisabled={countryDest != 'Indonesia' && countryDest != '' ? true : false}
                    onChange={(e: any) => separator(e?.value, setProvinsii, setProvinsiiDesc)}
                    options={prov}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    Sales Office
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Select
                    placeholder='Sales Office'
                    key={cusName}
                    onChange={(e: any) => setSalesAreaCode(e?.value)}
                    options={salesArea}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    Sales Group
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Select
                    key={cusName + salesAreaCode}
                    placeholder='Sales Group'
                    onChange={(e: any) => setCityData(e?.value)}
                    options={cityKontrak}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('order-tanggal-dari')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <input
                    type='date'
                    defaultValue={estimateFrom}
                    onChange={(e: any) => setEstimateFrom(e.target.value)}
                    className='form-control form-control-sm'
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('order-tanggal-berakhir')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <input
                    type='date'
                    defaultValue={estimate}
                    onChange={(e: any) => setEstimate(e.target.value)}
                    className='form-control form-control-sm'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('Assigner Name')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Form.Control
                    id='assignerName'
                    type='text'
                    key={initialAssignerName}
                    onChange={(e: any) => setassignerName(e.target.value)}
                    // defaultValue={initialAssignerName}
                    value={assignerName}
                    placeholder={t('Assigner Name')}
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('Assigner Position')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Form.Control
                    id='assignerPos'
                    type='text'
                    key={initialAssignerPos}
                    onChange={(e: any) => setassignerPos(e.target.value)}
                    // defaultValue={initialAssignerPos}
                    value={assignerPos}
                    placeholder={t('Assigner Position')}
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>{t('Ship To')}</p>
                </Col>
                <Col lg={7}>
                  <div className='d-flex'>
                    <Form.Control
                      className='me-1'
                      id='assignerName'
                      type='text'
                      disabled
                      value={customerrName}
                      placeholder={t('Ship To')}
                      size='sm'
                    />
                    <Button
                      className='btn btn-primary d-flex justify-content-center align-items-center'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('telusuri')}
                      onClick={handleCustomer}
                      disabled={showNum ? false : true}
                      size='sm'
                    >
                      <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                    </Button>

                    <Modal
                      show={show5}
                      onHide={handleClose5}
                      centered
                      size='lg'
                      backdrop='static'
                      keyboard={false}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('Browse')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <TableBrowseCustomer
                          customerList={fullCustomer}
                          paginateNumber={paginateNumber2}
                          numberURL={numberURL3}
                          onSelectCustomer={(item) => {
                            setCustomerr(item.customer_code)
                            setCustomerrName(item.name)
                            setCustomerShip(true)
                          }}
                        />
                      </Modal.Body>
                    </Modal>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
            <Row>
                    <Col sm={5}>
                      <p className='fs-4 mt-3'>{t('termasuk-ppn')}</p>
                    </Col>
                    <Col sm={7} className='d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='ppn'
                        className='mt-5 mb-2'
                        type='checkbox'
                        id='ckbox-ppn'
                        defaultChecked={includePPN}
                        onClick={() => setIncludePPN(!includePPN)}
                      />
                    </Col>
                  </Row>
            </Col>
            {/* <Col md={6}>
              <Row>
                <Col lg={5}>
                  <p className='fs-4 mt-3'>
                    {t('nomorIzinExport')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={7}>
                  <Form.Control
                    type='text'
                    onChange={(e: any) => setNoExport(e.target.value)}
                    placeholder={t('nomorIzinExport')}
                    size='sm'
                  />
                </Col>
              </Row>
            </Col> */}
          </Row>
          {showNum && (
            <div className='d-flex justify-content-start mt-8'>
              {tempItems.length > 0 && (
                <>
                  <button
                    onClick={() => (setShow7(true), setIndexItem([]))}
                    className='btn btn-primary me-2'
                  >
                    + {t('kontrak-tambah')} {t('Item')}
                  </button>
                  <Modal
                    show={show7}
                    onHide={handleClose7}
                    centered
                    size='xl'
                    backdrop='static'
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t('pilih')} Item</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {tempItems.map((item: any, index: any) => {
                        return (
                          <>
                            <Accordion>
                              <Accordion.Item eventKey={index}>
                                <Accordion.Header>
                                  {item?.id} / {item?.produsen?.name} / {item?.product_name} /{' '}
                                  {item?.incoterm1?.code}
                                  {item?.incoterm2 != null
                                    ? '-' + item.incoterm2.code
                                    : item.incoterm2_id != null && item.incoterm2_id != '0'
                                    ? '-' + item.incoterm2_id
                                    : ''}{' '}
                                  / {item?.fixed_quantum} Ton
                                </Accordion.Header>
                                <Accordion.Body style={{backgroundColor: '#fff'}}>
                                  {sektorid == 1 && (
                                    <Row>
                                      <Col md='6'>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('pilih')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              id={'checkbox' + index}
                                              value={index}
                                              // disabled={!data.have_action}
                                              onClick={() => onclickCheckBox(index)}
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>Sales Org</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item.produsen?.name || item.sales_org_code_desc
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item.incoterm1?.code || item.incoterm1_desc}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={
                                                item.province?.region_name || item.province_desc
                                              }
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item.product_type_desc}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={
                                                item.plant == null
                                                  ? ''
                                                  : item.plant + ' - ' + item.plant_desc
                                              }
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? t('sack')
                                                : t(
                                                    'CREATE_CONTRACT.ADD_ITEM_MODAL.QUANTUM_SIP_LABEL'
                                                  )}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            {item.product_type_desc == 'KANTONG/SACK' ? (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(item.fixed_quantum).toLocaleString(
                                                        'en',
                                                        {
                                                          maximumFractionDigits: 4,
                                                        }
                                                      ) + ' EA'
                                                    : parseFloat(item.fixed_quantum).toLocaleString(
                                                        'id',
                                                        {
                                                          maximumFractionDigits: 4,
                                                        }
                                                      ) + ' EA'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(item.fixed_quantum).toLocaleString(
                                                        'en',
                                                        {
                                                          maximumFractionDigits: 4,
                                                        }
                                                      ) + ' Ton'
                                                    : parseFloat(item.fixed_quantum).toLocaleString(
                                                        'id',
                                                        {
                                                          maximumFractionDigits: 4,
                                                        }
                                                      ) + ' Ton'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? t('sack')
                                                : t(
                                                    'CREATE_CONTRACT.ADD_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL'
                                                  )}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            {item.product_type_desc == 'KANTONG/SACK' ? (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                    : parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                    : parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              size='sm'
                                              type='text'
                                              id='shipping'
                                              value={
                                                item?.shipping_tolerance != '0'
                                                  ? item?.shipping_tolerance + ' %'
                                                  : ''
                                              }
                                              disabled
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item?.payment_type_1_desc || item?.payment_type_1
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={t(item?.payment_note || item?.payment_notes)}
                                              as='textarea'
                                              disabled
                                              size='sm'
                                              style={{height: '40px'}}
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item.end_user_detail?.name
                                                  ? item.end_user_detail?.name
                                                  : item.end_user
                                              }
                                              as='textarea'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col md='6'>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>ID</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item?.id}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={t(item.sector?.name || 'Domestik Korperasi')}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                          </Col>
                                          <Col md={7}>
                                            {item?.incoterm2 == null ? (
                                              <Form.Control
                                                value={
                                                  item?.incoterm2_id == null ||
                                                  item?.incoterm2_id == '0'
                                                    ? ''
                                                    : item?.incoterm2_id
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={item?.incoterm2?.code}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={item?.city?.city_name || item?.city_desc}
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item?.material_number?.slice(-7) +
                                                '-' +
                                                item?.product_name
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              as='textarea'
                                              style={{height: '40px'}}
                                              value={item.product_spec}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {t('sub-order-hargaD')}/
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? item.unit
                                                : 'Ton'}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item.has_usd_price ? 
                                                  'USD ' + (parseInt(item?.price_usd).toLocaleString(
                                                      i18next.language,
                                                      {maximumFractionDigits: 4}
                                                    )) : ('Rp ' + (i18next.language === 'en'
                                                  ? parseInt(item?.fixed_price).toLocaleString(
                                                      'en',
                                                      {maximumFractionDigits: 4}
                                                    )
                                                  : parseInt(item?.fixed_price).toLocaleString(
                                                      'id',
                                                      {maximumFractionDigits: 4}
                                                    )))
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? t('sack')
                                                : t('sisaquantum')}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            {item.product_type_desc == 'KANTONG/SACK' ? (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                    : (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                    : (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-5'>
                                          <Col md={5}>
                                            <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                          </Col>
                                          <Col sm={7} className='d-flex justify-content-start'>
                                            <Form.Check
                                              reverse
                                              name='ppn'
                                              className='mt-4 mb-2'
                                              type='checkbox'
                                              id='ckbox-ppn'
                                              checked={item?.include_ppn}
                                              disabled
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item?.payment_type_2_desc}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('segment')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={t(item.segment_name)}
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item?.notes}
                                              as='textarea'
                                              style={{height: '40px'}}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  )}

                                  {sektorid == 3 && (
                                    <Row>
                                      <Col md='6'>
                                        <Row className='mb-6'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('pilih')}</p>
                                          </Col>
                                          <Col md={7} className='d-flex align-items-center'>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              id={'checkbox' + index}
                                              value={index}
                                              // disabled={!data.have_action}
                                              onClick={() => onclickCheckBox(index)}
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>Sales Org</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item.produsen?.name || item.sales_org_code_desc
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item.incoterm1?.code || item.incoterm1_desc}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={
                                                item.province?.region_name || item.province_desc
                                              }
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                payloadDesc[tempIndex] || item.product_type_desc
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={
                                                payloadPlantID[tempIndex] == null
                                                  ? ''
                                                  : payloadPlantID[tempIndex] +
                                                      ' - ' +
                                                      payloadPlantDesc[tempIndex] ||
                                                    item.plant + ' - ' + item.plant_desc
                                              }
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? t('sack')
                                                : t(
                                                    'CREATE_CONTRACT.ADD_ITEM_MODAL.QUANTUM_SIP_LABEL'
                                                  )}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            {item.product_type_desc == 'KANTONG/SACK' ? (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(
                                                        payloadQuantum[tempIndex] ||
                                                          item.fixed_quantum
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                    : parseFloat(
                                                        payloadQuantum[tempIndex] ||
                                                          item.fixed_quantum
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(
                                                        payloadQuantum[tempIndex] ||
                                                          item.fixed_quantum
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' MT'
                                                    : parseFloat(
                                                        payloadQuantum[tempIndex] ||
                                                          item.fixed_quantum
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' MT'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? t('sack')
                                                : t(
                                                    'CREATE_CONTRACT.ADD_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL'
                                                  )}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            {item.product_type_desc == 'KANTONG/SACK' ? (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                    : parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' MT'
                                                    : parseFloat(
                                                        item.quantum_contract
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' MT'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                          </Col>
                                          <Col sm={7}>
                                            <Form.Control
                                              size='sm'
                                              type='text'
                                              id='shipping'
                                              value={
                                                item?.shipping_tolerance != '0'
                                                  ? item?.shipping_tolerance + ' %'
                                                  : ''
                                              }
                                              disabled
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item?.payment_type_1_desc || item?.payment_type_1
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={t(item?.payment_note || item?.payment_notes)}
                                              as='textarea'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col md='6'>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>ID</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item?.id}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={t(item.sector?.name || 'Ekspor')}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                          </Col>
                                          <Col md={7}>
                                            {item?.incoterm2 == null ? (
                                              <Form.Control
                                                value={
                                                  item?.incoterm2_id == null ||
                                                  item?.incoterm2_id == '0'
                                                    ? ''
                                                    : item?.incoterm2_id
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={item?.incoterm2?.code}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              type='text'
                                              value={item?.city?.city_name || item?.city_desc}
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                payloadMaterial[tempIndex]
                                                  ? payloadMaterial[tempIndex]?.slice(-7) +
                                                    '-' +
                                                    payloadName[tempIndex]
                                                  : item?.material_number?.slice(-7) +
                                                    '-' +
                                                    item?.product_name
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              as='textarea'
                                              style={{height: '40px'}}
                                              value={payloadSpec[tempIndex] || item.product_spec}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {t('sub-order-hargaD')}/
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? item.unit
                                                : 'MT'}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                'USD ' + (i18next.language === 'en'
                                                  ? parseFloat(
                                                      payloadHarga[tempIndex] || item?.fixed_price
                                                    ).toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : parseFloat(
                                                      payloadHarga[tempIndex] || item?.fixed_price
                                                    ).toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })
                                              )}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>
                                              {item.product_type_desc == 'KANTONG/SACK'
                                                ? t('sack')
                                                : t('sisaquantum')}
                                            </p>
                                          </Col>
                                          <Col md={7}>
                                            {item.product_type_desc == 'KANTONG/SACK' ? (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                    : (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' EA'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            ) : (
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                    : (
                                                        parseFloat(item.fixed_quantum) -
                                                        parseFloat(item.quantum_contract)
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item?.notes}
                                              as='textarea'
                                              style={{height: '40px'}}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={item?.payment_type_2_desc}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                        <Row className='mb-4'>
                                          <Col md={5}>
                                            <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                          </Col>
                                          <Col md={7}>
                                            <Form.Control
                                              value={
                                                item.end_user_detail?.name
                                                  ? item.end_user_detail?.name
                                                  : item.end_user
                                              }
                                              as='textarea'
                                              disabled
                                              size='sm'
                                            />
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  )}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </>
                        )
                      })}
                      <div className='d-flex justify-content-end mt-5'>
                        <Button
                          className='justify-content-end me-1'
                          onClick={() => addInOrder('all')}
                          hidden={tempItems.length < 2 ? true : false}
                        >
                          {t('selectall')}
                        </Button>
                        <Button
                          className='justify-content-end'
                          hidden={tempItems.length < 1 ? true : false}
                          onClick={() => {
                            addInOrder('satuan')
                            // dispatch(addOrderItem(item))
                          }}
                        >
                          {t('Save')}
                        </Button>
                      </div>
                    </Modal.Body>
                  </Modal>
                </>
              )}
              {addedProduct.length > 0 ? (
                <>
                  <button className='btn btn-primary me-2' onClick={handleAddProduct}>
                    + {t('Add New Product')}
                  </button>
                </>
              ) : (
                <></>
              )}
              <Modal
                show={show4}
                onHide={handleClose4}
                centered
                backdrop='static'
                keyboard={false}
                scrollable
                size='xl'
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('kontrak-tambah')} {t('kontrak-produk')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {sektorid == 3 && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('kontrak-produsen')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={salesOrgDesc}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-incoterm1')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={incotermIdDesc}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-provinsi')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Select
                                id='provinsi'
                                placeholder={t('pilih')}
                                onChange={(e: any) => {
                                  setFullCity2([])
                                  separator2(e?.value, setProvince, setProvinceDesc)
                                  setpro(e?.value)
                                  fieldClear()
                                  fieldClearer(5)
                                }}
                                options={fullProvince2}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-jenis')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Select
                                size='sm'
                                aria-label='Default select example'
                                onChange={(e: any) => separator2(e.target.value, setPtype, setPtype2)}
                              >
                                <option hidden value=','>
                                  {t('Pilih-productType')}
                                </option>
                                {fullProductType.map((item: any) => {
                                  return (
                                    <>
                                      <option
                                        value={item.material_group + '~#~' + item.material_group_desc}
                                      >
                                        {item.material_group_desc}
                                      </option>
                                    </>
                                  )
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                          {parseInt(pnumber) == 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='fs-6'>
                                  Custom Product Name<span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={7}>
                                <Form.Control
                                  placeholder=' Custom Product Name'
                                  size='sm'
                                  aria-label='Default select example'
                                  type='text'
                                  id='custom'
                                  onChange={(e: any) => setPname(e.target.value)}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {ptype2 != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <InputGroup size='sm'>
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='kuantum'
                                  key={pname}
                                  placeholder={
                                    ptype2 != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')
                                  }
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setQuantum(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={3}
                                />
                                <InputGroup.Text id='basic-addon2'>
                                  {ptype2 == 'KANTONG/SACK' ? punit : 'MT'}
                                </InputGroup.Text>
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={7}>
                              {ptype2 != 'KANTONG/SACK' ? (
                                <InputGroup>
                                  <Form.Control
                                    key={pname + ptype}
                                    placeholder={t('Shipping Tolerance')}
                                    size='sm'
                                    type='text'
                                    onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                    id='shipping'
                                  />
                                  <InputGroup.Text
                                    id='basic-addon2'
                                    style={{paddingTop: '1px', paddingBottom: '1px'}}
                                  >
                                    <span className='px-1'>%</span>
                                  </InputGroup.Text>
                                </InputGroup>
                              ) : (
                                <InputGroup>
                                  <Form.Control
                                    key={pname + ptype}
                                    size='sm'
                                    type='number'
                                    onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                    id='shipping'
                                    disabled
                                  />
                                  <InputGroup.Text
                                    id='basic-addon2'
                                    style={{paddingTop: '1px', paddingBottom: '1px'}}
                                  >
                                    <span className='px-1'>%</span>
                                  </InputGroup.Text>
                                </InputGroup>
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-3'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('sub-order-payment1')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control size='sm' value={t(p1)} disabled />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='mt-3 fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('keterangan')}
                                id='keterangan'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setketerangan(e.target.value)}
                              />
                            </Col>
                          </Row>

                          <Row className=''>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('sub-order-endUser')}
                                {ptype2 != 'KANTONG/SACK' ? (
                                  <span className='text-danger'>*</span>
                                ) : (
                                  ''
                                )}
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                as='textarea'
                                id='enduser'
                                placeholder={t('sub-order-endUser')}
                                onChange={(e: any) => {
                                  setEnduser(e.target.value)
                                  setEnduserDesc(e.target.value)
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-sektor')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={t('Export')}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={incotermId2Desc}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col sm={7}>
                            <Select
                                id='kota'
                                placeholder={t('pilih')}
                                key={province}
                                onChange={(e: any) => {
                                  fieldClearer(3)
                                  separator2(e?.value, setCity, setCityDesc)
                                }}
                                options={fullCity2}/>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='mt-3'>
                                {t('sub-order-produk')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Select
                                id='produk'
                                key={ptype}
                                placeholder={t('pilih')}
                                defaultValue={
                                  fullProductName[
                                    fullProductName.findIndex(
                                      (item: any) => item.truevalue == parseInt(pnumber)
                                    )
                                  ]
                                }
                                onChange={(e: any) => {
                                  let _split = e?.value?.split('~#~')
                                  setQuantum(0)
                                  setSubprice(0)
                                  separator2(e?.value, setPnumber, setPname)
                                  setPunit(_split[2])
                                }}
                                options={fullProductName}
                              />
                            </Col>
                          </Row>
                          {parseInt(pnumber) == 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={7}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setNote(e.target.value)}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row className='mb-4'>
                            <Col md={5} className='d-flex align-items-center'>
                              <p className='fs-6'>
                                {t('sub-order-hargaP')}/{ptype2 != 'KANTONG/SACK' ? 'MT' : punit}
                                {ptype2 != 'KANTONG/SACK' ? (
                                  <span className='text-danger'>*</span>
                                ) : (
                                  <span className='text-danger'></span>
                                )}
                              </p>
                            </Col>
                            <Col sm={7}>
                              <InputGroup size='sm'>
                                <InputGroup.Text id='basic-addon2'>
                                  <span className='px-2'>USD</span>
                                </InputGroup.Text>
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  key={pname}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setSubprice(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={2}
                                  placeholder={t('sub-order-hargaP')}
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                placeholder={t('sub-order-spek')}
                                as='textarea'
                                id='spek'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setPspec(e.target.value)}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control size='sm' value={t(p2)} disabled />
                            </Col>
                          </Row>
                          {parseInt(pnumber) != 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={7}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setNote(e.target.value)}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}

                  {sektorid == 1 && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('kontrak-produsen')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={salesOrgDesc}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-incoterm1')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={incotermIdDesc}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-provinsi')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Select
                                id='provinsi'
                                placeholder={t('pilih')}
                                onChange={(e: any) => {
                                  setFullCity2([])
                                  separator2(e?.value, setProvince, setProvinceDesc)
                                  setpro(e?.value)
                                  fieldClear()
                                  fieldClearer(5)
                                }}
                                options={fullProvince2}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-jenis')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Select
                                size='sm'
                                key={province + city}
                                aria-label='Default select example'
                                onChange={(e: any) => {
                                  fieldClearer(2)
                                  separator2(e.target.value, setPtype, setPtype2)
                                }}
                              >
                                <option hidden value='~#~'>
                                  {t('Pilih-productType')}
                                </option>
                                {fullProductType.map((item: any, index: number) => {
                                  return (
                                    <option
                                      key={item?.material_group ?? index}
                                      value={item.material_group + '~#~' + item.material_group_desc}
                                    >
                                      {t(item.material_group_desc)}
                                    </option>
                                  )
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                          {parseInt(pnumber) == 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='fs-6'>
                                  Custom Product Name<span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={7}>
                                <Form.Control
                                  placeholder=' Custom Product Name'
                                  size='sm'
                                  aria-label='Default select example'
                                  type='text'
                                  id='custom'
                                  onChange={(e: any) => setPname(e.target.value)}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {ptype2 != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <InputGroup size='sm'>
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='kuantum'
                                  key={pname}
                                  placeholder={
                                    ptype2 != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')
                                  }
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setQuantum(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={3}
                                />
                                <InputGroup.Text id='basic-addon2'>
                                  {ptype2 != 'KANTONG/SACK' ? (
                                    <span>Ton</span>
                                  ) : (
                                    <span className='pe-1'>EA</span>
                                  )}
                                </InputGroup.Text>
                              </InputGroup>
                            </Col>
                          </Row>
                          {ptype2 != 'KANTONG/SACK' ? (
                            <Row className='mb-3'>
                              <Col md={5}>
                                <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                              </Col>
                              <Col sm={7}>
                                <InputGroup>
                                  <Form.Control
                                    key={pname + ptype}
                                    placeholder={t('Shipping Tolerance')}
                                    size='sm'
                                    type='number'
                                    onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                    id='shipping'
                                  />
                                  <InputGroup.Text
                                    id='basic-addon2'
                                    style={{paddingTop: '1px', paddingBottom: '1px'}}
                                  >
                                    <span className='px-1'>%</span>
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                          ) : (
                            <Row className='mb-3'>
                              <Col md={5}>
                                <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                              </Col>
                              <Col sm={7}>
                                <InputGroup>
                                  <Form.Control size='sm' type='text' id='shipping' disabled />
                                  <InputGroup.Text
                                    id='basic-addon2'
                                    style={{paddingTop: '1px', paddingBottom: '1px'}}
                                  >
                                    <span className='px-1'>%</span>
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                          )}
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('sub-order-payment1')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control size='sm' value={t(p1)} disabled />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='mt-3 fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('keterangan')}
                                id='keterangan'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setketerangan(e.target.value)}
                              />
                            </Col>
                          </Row>

                          {parseInt(pnumber) != 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='mt-3 fs-6'>
                                  {t('segment')}
                                  <span className='text-danger'>*</span>{' '}
                                </p>
                              </Col>
                              <Col md={7}>
                                <Form.Select
                                  id='segment'
                                  onChange={(e: any) =>
                                    separator2(e.target.value, setSegment, setSegmentDesc)
                                  }
                                  aria-label='Default select example'
                                  size='sm'
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-segment')}
                                  </option>
                                  {fullSegment.map((item: any) => {
                                    if (item.code == 'Z2' || item.code == 'Z3') {
                                      return (
                                        <option value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    }
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                          )}

                          <Row className=''>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('sub-order-endUser')}
                                {ptype2 != 'KANTONG/SACK' ? (
                                  <span className='text-danger'>*</span>
                                ) : (
                                  ''
                                )}
                              </p>
                            </Col>
                            <Col sm={7}>
                              {isNoEnduser ? (
                                <>
                                  <Form.Control
                                    size='sm'
                                    as='textarea'
                                    id='enduser'
                                    placeholder={t('sub-order-endUser')}
                                    onChange={(e: any) => {
                                      setEnduser(e.target.value)
                                      setEnduserDesc(e.target.value)
                                    }}
                                  />
                                </>
                              ) : (
                                <>
                                  <MultiSelect
                                    options={fullEndUser?.map((item: any) => {
                                      return {label: t(item.name), value: item.name}
                                    })}
                                    value={arrayEnduser}
                                    onChange={(e: any) => {
                                      let user = handleUser(e)
                                      setEnduserArray(e)
                                      setEnduserDesc(user.toString())
                                    }}
                                    labelledBy='Select'
                                  />
                                </>
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}></Col>
                            <Col sm={7} className='d-flex align-items-center'>
                              <Form.Check
                                onClick={() => {
                                  setIsNoEnduser(!isNoEnduser)
                                }}
                                defaultChecked={isNoEnduser}
                                name='noenduser'
                                disabled={disableCKBOX}
                                id='noenduser'
                                className='mt-5 mb-2'
                                type='checkbox'
                              />
                              {i18next.language == 'en' ? (
                                <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                          </Row>
                          {/*

                          <Row className='mb-4'>
                            <Col md={5}></Col>
                            <Col sm={7} className='d-flex align-items-center'>
                              <Form.Check
                                onClick={() => {
                                  setIsNoEnduser(!isNoEnduser)
                                }}
                                defaultChecked={isNoEnduser}
                                name='noenduser'
                                disabled={disableCKBOX}
                                id='noenduser'
                                className='mt-5 mb-2'
                                type='checkbox'
                              />
                              {i18next.language == 'en' ? (
                                <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                          </Row> */}
                        </Col>
                        <Col md={6}>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-sektor')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                disabled
                                defaultValue={t('Domestik Korperasi')}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            {incotermId2Desc != '0' ? (
                              <Col sm={7}>
                                <Form.Control
                                  size='sm'
                                  aria-label='Default select example'
                                  disabled
                                  defaultValue={incotermId2Desc ? incotermId2Desc : ''}
                                />
                              </Col>
                            ) : (
                              <Col sm={7}>
                                <Form.Control
                                  size='sm'
                                  aria-label='Default select example'
                                  disabled
                                  defaultValue=''
                                />
                              </Col>
                            )}
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>
                                {t('sub-order-kota')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Select
                                id='kota'
                                placeholder={t('pilih')}
                                key={province}
                                onChange={(e: any) => {
                                  fieldClearer(3)
                                  separator2(e?.value, setCity, setCityDesc)
                                }}
                                options={fullCity2}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>
                                {t('sub-order-produk')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={7}>
                              <Select
                                id='produk'
                                placeholder={t('pilih')}
                                key={ptype + province + city}
                                defaultValue={
                                  fullProductName[
                                    fullProductName.findIndex(
                                      (item: any) => item.truevalue == parseInt(pnumber)
                                    )
                                  ]
                                }
                                onChange={(e: any) => {
                                  let _split = e?.value?.split("~#~")
                                  fieldClearer(1)
                                  setQuantum(0)
                                  setSubprice(0)
                                  separator2(e?.value, setPnumber, setPname)
                                  setPunit(_split[2])
                                }}
                                options={fullProductName}
                              />
                            </Col>
                          </Row>
                          {parseInt(pnumber) == 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={7}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setNote(e.target.value)}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row className='mb-2'>
                            <Col md={5} className='d-flex align-items-center'>
                              <p className='fs-6'>
                                {t('sub-order-hargaP')}/{ptype2 != 'KANTONG/SACK' ? 'Ton' : punit}
                                {ptype2 != 'KANTONG/SACK' ? (
                                  <span className='text-danger'>*</span>
                                ) : (
                                  ''
                                )}
                              </p>
                            </Col>
                            <Col sm={7}>
                              <InputGroup size='sm'>
                                <InputGroup.Text id='basic-addon2'>
                                  <span className='px-1'>Rp</span>
                                </InputGroup.Text>
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  key={pname}
                                  defaultValue={subprice}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setSubprice(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={-1}
                                  placeholder={t('sub-order-hargaP')}
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={7} className='d-flex justify-content-start'>
                              {ptype2 != 'KANTONG/SACK' ? (
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-3 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                />
                              ) : (
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-3 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  disabled
                                />
                              )}
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control size='sm' value={t(p2)} disabled />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={5}>
                              <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col sm={7}>
                              <Form.Control
                                placeholder={t('sub-order-spek')}
                                as='textarea'
                                id='spek'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setPspec(e.target.value)}
                              />
                            </Col>
                          </Row>
                          {parseInt(pnumber) != 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={7}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setNote(e.target.value)}
                                />
                              </Col>
                            </Row>
                          )}
                          {parseInt(pnumber) == 0 && (
                            <Row className='mb-4'>
                              <Col md={5}>
                                <p className='mt-3 fs-6'>
                                  {t('segment')}
                                  <span className='text-danger'>*</span>{' '}
                                </p>
                              </Col>
                              <Col md={7}>
                                <Form.Select
                                  id='segment'
                                  onChange={(e: any) =>
                                    separator2(e.target.value, setSegment, setSegmentDesc)
                                  }
                                  aria-label='Default select example'
                                  size='sm'
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-segment')}
                                  </option>
                                  {fullSegment.map((item: any) => {
                                    if (item.code == 'Z2' || item.code == 'Z3') {
                                      return (
                                        <option value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    }
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                  <div className='d-flex justify-content-end mt-5'>
                    <Button variant='primary' onClick={() => insertAddOrder()}>
                      <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                      {t('order-kirim')}
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
              <button className='btn btn-primary' onClick={handleShow1}>
                {t('addtional')} {t('text')}
              </button>
              <Modal
                show={show1}
                onHide={handleClose11}
                centered
                backdrop='static'
                keyboard={false}
                scrollable
                size='lg'
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                      {t('addtional')} {t('text')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                  <div className="d-flex justify-content-end mb-3">
                    <div style={{maxWidth: 140}} className='btn-lang d-flex'>
                      <button
                        className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'id' ? 'active' : '')}
                        onClick={()=> setAddTextLanguage('id')}
                      >
                        <h6 className='ms-1'>Ind</h6>
                      </button>
                      <button
                        className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'en' ? 'active' : '')}
                        onClick={()=> setAddTextLanguage('en')}
                      >
                        <h6 className='ms-1'>Eng</h6>
                      </button>
                    </div>
                  </div>


                  { addTextLanguage == 'id' && <div>
                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Judul'}
                        onClick={handleOpenn}
                        id='titlee'
                      >
                        <div className='text-light'>{t('Judul')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'Judul'}>
                      <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setTitlee(e.target.value)}
                        placeholder={t('Judul')}
                        defaultValue={titlee}
                      />
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTitle}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'nama'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('customer pic name')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'nama'}>
                      <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setCustomer_pic_namee(e.target.value)}
                        placeholder={t('customer pic name')}
                        defaultValue={customer_pic_namee}
                      />
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveName}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Position'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('customer pic position')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'Position'}>
                      <RichText
                        containerClassName='mt-4'
                        content={customer_pic_positionn}
                        onUpdate={({editor}) => setCustomer_pic_positionn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSavePosition}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'terms_and_conditions'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('terms_and_conditions')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'terms_and_conditions'}>
                      <RichText
                        containerClassName='mt-4'
                        content={terms_and_conditionss}
                        onUpdate={({editor}) => setTerms_and_conditionss(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveSyarat}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'mail_body'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('mail_body')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'mail_body'}>
                      <RichText
                        containerClassName='mt-4'
                        content={mail_bodyy}
                        onUpdate={({editor}) => setMail_bodyy(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveMail}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer_attn'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('customer_attn')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'customer_attn'}>
                      <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setCustomer_attnn(e.target.value)}
                        placeholder={t('customer_attn')}
                        defaultValue={customer_attnn}
                      />
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveAttn}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'port_of_discharge'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('port_of_discharge')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'port_of_discharge'}>
                      <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setPort_of_dischargee(e.target.value)}
                        placeholder={t('port_of_discharge')}
                        defaultValue={port_of_dischargee}
                      />
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSavePort}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'other'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('other')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'other'}>
                      <RichText
                        containerClassName='mt-4'
                        content={lain_lainn}
                        onUpdate={({editor}) => setLain_lainn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'order-keterangan'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('order-keterangan')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'order-keterangan'}>
                      <RichText
                        containerClassName='mt-4'
                        content={keterangannn}
                        onUpdate={({editor}) => setKeterangannn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'textPenutup'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('textPenutup')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'textPenutup'}>
                      <RichText
                        containerClassName='mt-4'
                        content={textPenutupp}
                        onUpdate={({editor}) => setTextPenutupp(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTextPenutup}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'nomorIzinExport'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('nomorIzinExport')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'nomorIzinExport'}>
                      <RichText
                        containerClassName='mt-4'
                        content={noExportt}
                        onUpdate={({editor}) => setNoExportt(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveNoExport}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  </div> }
                  { addTextLanguage == 'en' && <div>
                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Judul'}
                        onClick={handleOpenn}
                        id='titlee'
                      >
                        <div className='text-light'>{t('Judul')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'Judul'}>
                      <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setTitleeEn(e.target.value)}
                        placeholder={t('Judul')}
                        defaultValue={titleeEn}
                      />
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTitle}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'terms_and_conditions'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('terms_and_conditions')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'terms_and_conditions'}>
                      <RichText
                        containerClassName='mt-4'
                        content={terms_and_conditionssEn}
                        onUpdate={({editor}) => setTerms_and_conditionssEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveSyarat}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'mail_body'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('mail_body')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'mail_body'}>
                      <RichText
                        containerClassName='mt-4'
                        content={mail_bodyyEn}
                        onUpdate={({editor}) => setMail_bodyyEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveMail}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer_attn'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('customer_attn')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'customer_attn'}>
                      <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setCustomer_attnnEn(e.target.value)}
                        placeholder={t('customer_attn')}
                        defaultValue={customer_attnnEn}
                      />
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveAttn}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'other'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('other')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'other'}>
                      <RichText
                        containerClassName='mt-4'
                        content={lain_lainnEn}
                        onUpdate={({editor}) => setLain_lainnEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'order-keterangan'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('order-keterangan')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'order-keterangan'}>
                      <RichText
                        containerClassName='mt-4'
                        content={keterangannnEn}
                        onUpdate={({editor}) => setKeterangannnEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'textPenutup'}
                        onClick={handleOpenn}
                      >
                        <div className='text-light'>{t('textPenutup')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'textPenutup'}>
                      <RichText
                        containerClassName='mt-4'
                        content={textPenutuppEn}
                        onUpdate={({editor}) => setTextPenutuppEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTextPenutup}>
                          {t('Save')}
                        </button>
                      </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  </div> }

                </Modal.Body>
              </Modal>
              <Button
                onClick={() => {
                  setShowLetter(true)
                }}
                className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('preview')}
              >
                {t('preview')}
              </Button>
              <Modal
                show={showLetter}
                onHide={handleCloseLetter}
                size='xl'
                backdrop='static'
                keyboard={false}
                scrollable
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('preview')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <ViewLetter data={letterData} type='kontrak' />
                </Modal.Body>
              </Modal>
            </div>
          )}

          <div className='table-responsive mt-2 bdr' style={{marginBottom: '3rem'}}>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead className='border-bottom'>
                <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-order-1 text-center'>{t('kontrak-item')}</th>
                  <th className='td-order-2 text-center'>Status</th>
                  <th className='td-order-4 text-center'>{t('kontrak-aksi')}</th>
                  <th className='td-order-3 text-center'>Sales Org </th>
                  <th className='td-order-2 text-center'>{t('kontrak-incoterm')} </th>
                  <th className='td-order-3 text-center'>{t('kontrak-wilayah')}</th>
                  {sektorid == 1 ? <th className='td-order-2 text-center'>{t('segment')}</th> : ''}
                  <th className='td-order-3 text-center'>{t('sub-order-endUser')}</th>
                  <th className='td-order-3 text-center'>{t('Sector')} </th>
                  <th className='td-order-2 text-center'>{t('kontrak-jenis')} </th>
                  <th className='td-order-2 text-center'>{t('Product Code')} </th>
                  <th className='td-order-4 text-center'>{t('kontrak-nama')} </th>
                  <th className='td-order-2 text-center'>{t('kontrak-spek')}</th>
                  <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                  {/* <th className='td-order-2 text-center'>{t('CREATE_CONTRACT.TABLE.SHIPPING_TOLERANCE_LABEL')}</th> */}
                  {/* <th className='td-order-2 text-center mt-4'>{t('Price')}</th> */}
                  <th className='td-order-2 text-center'>{t('Price')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-hargaPPN')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-ppn')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-hargaSPPN')}</th>
                  {/* <th className='td-order-2 text-center'>Status {t('Price')}</th> */}
                  {/* <th className='td-order-2 text-center'>{t('kontrak-kuantum')}</th> */}
                  {sektorid == 2 ? (
                    <th className='td-order-2 text-center'>{t('kontrak-Gudang')} </th>
                  ) : (
                    ''
                  )}
                </tr>
              </thead>
              {addedProduct != null ? (
                <tbody>
                  {addedProduct?.map((showNums: any, _index: number) => {
                    return (
                      <tr
                        key={showNums?.id ?? _index}
                        className='d-flex jusify-content-center w-100 align-items-center'
                      >
                        <td className='td-order-1 text-center column' id='itemId'>
                          <span className='d-block fs-6 py-3' style={{margin: '.2px 0'}}>
                            {_index + 1}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {' '}
                            <span className='badge badge-light-primary'>
                              {' '}
                              {t(showNums.status_text_sip)}{' '}
                            </span>{' '}
                          </span>
                        </td>
                        <td className='td-order-4 column'>
                          <div
                            className='d-flex justify-content-center'
                            style={{margin: '1.3px 0'}}
                          >
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              onClick={() => {
                                setIdItem(showNums?.id)
                                setTempIndex(_index)
                                setCity(showNums?.city?.id)
                                setPlantName(showNums.plant_desc)
                                setPlantID(showNums.plant)
                                setTempDetail(showNums)
                                handleShow()
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            {showNums.id ? (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                                onClick={() => {
                                  setFileBox(showNums)
                                  setSubOrderID(
                                    showNums.order_sub_item_id == null
                                      ? showNums?.id
                                      : showNums?.order_sub_item_id
                                  )
                                  ambilAttachment(
                                    showNums.order_sub_item_id == null
                                      ? showNums?.id
                                      : showNums?.order_sub_item_id
                                  )
                                  setShowUpload(true)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/archive-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                                onClick={() => {
                                  setFileBox(showNums)
                                  setIndex3(_index)
                                  removeFileState()
                                  handleUploadOrderItem(showNums)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/archive-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}

                            {showNums.id ? (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Jadwal')}
                                onClick={() => {
                                  setIDSector(showNums.sector_id)
                                  setProvinceName(
                                    showNums.province?.region_name || showNums?.province_desc
                                  )
                                  setCityName(showNums.city?.city_name || showNums?.city_desc)
                                  setProductName(payloadName[_index] || showNums?.product_name)
                                  formattingTon(payloadQuantum[_index] || showNums?.fixed_quantum)
                                  setJadwalID(
                                    showNums.order_sub_item_id == null
                                      ? showNums?.id
                                      : showNums?.order_sub_item_id
                                  )
                                  setShowJadwal(true)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/calendar-check-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Jadwal')}
                                onClick={() => {
                                  setIDSector(showNums.sector_id)
                                  setProvinceName(
                                    showNums.province?.region_name || showNums?.province_desc
                                  )
                                  setCityName(showNums.city?.city_name || showNums?.city_desc)
                                  setProductName(payloadName[_index] || showNums?.product_name)
                                  setPtypee(payloadType[_index] || showNums?.product_type)
                                  setPunit(showNums?.unit)
                                  formattingTon(payloadQuantum[_index] || showNums?.fixed_quantum)
                                  setIndex2(_index)
                                  handleJadwal(showNums)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/calendar-check-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}

                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('ubah')}
                              onClick={() => {
                                dispatch(
                                  setOrderItem({
                                    id: showNums?.id,
                                    at_sales_option: showNums?.at_sales_option,
                                    city_id: showNums?.city_id,
                                    end_user: showNums?.end_user,
                                    fixed_price: showNums?.fixed_price,
                                    fixed_quantum: showNums?.fixed_quantum,
                                    include_ppn: showNums?.include_ppn,
                                    incoterm1_id: showNums?.incoterm1_id,
                                    incoterm2_id: showNums?.incoterm2_id,
                                    is_new: showNums?.is_new,
                                    material_number: showNums?.material_number,
                                    unit: showNums?.unit,
                                    notes: showNums?.notes,
                                    payment_note: showNums?.payment_note,
                                    payment_type_1: showNums?.payment_type_1,
                                    payment_type_1_desc: showNums?.payment_type_1_desc,
                                    payment_type_2: showNums?.payment_type_2,
                                    payment_type_2_desc: showNums?.payment_type_2_desc,
                                    plant: showNums?.plant,
                                    plant_desc: showNums?.plant_desc,
                                    product_name: showNums?.product_name,
                                    product_spec: showNums?.product_spec,
                                    product_type: showNums?.product_type,
                                    product_type_desc: showNums?.product_type_desc,
                                    province_id: showNums?.province_id,
                                    quantum_contract: showNums?.quantum_contract,
                                    sales_org_code: showNums?.sales_org_code,
                                    sector_id: showNums?.sector_id,
                                    segment_code: showNums?.segment_code,
                                    segment_name: showNums?.segment_name,
                                    shipping_tolerance: showNums?.shipping_tolerance,
                                    shipping_tolerance_contract: showNums?.shipping_tolerance_contract,
                                    sloc: showNums?.sloc,
                                    sloc_description: showNums?.sloc_description,
                                    material_desc_en: showNums?.material_desc_en,
                                    plant_desc_en: showNums?.plant_desc_en,
                                    has_usd_price: showNums?.has_usd_price,
                                    price_usd: showNums?.price_usd,
                                  })
                                )

                                setIdItem(showNums?.id ? showNums?.id : '')
                                setKuantumSisa(
                                  parseFloat(showNums.fixed_quantum) -
                                    parseFloat(showNums.quantum_contract)
                                )
                                setPlant(
                                  payloadPlantID[_index] ? payloadPlantID[_index] : showNums?.plant
                                )
                                setSalesOption(showNums.at_sales_option)
                                setPlantt(
                                  payloadPlantID[_index]
                                    ? payloadPlantID[_index] + '~#~' + payloadPlantDesc[_index]
                                    : showNums?.plant + '~#~' + showNums?.plant_desc
                                )
                                setPlanttt(
                                  payloadPlantID[_index] ? payloadPlantID[_index] : showNums?.plant
                                )
                                setPlantDesc(
                                  payloadPlantDesc[_index]
                                    ? payloadPlantDesc[_index]
                                    : showNums?.plant_desc
                                )
                                setslocId(
                                  payloadSloc[_index] ? payloadSloc[_index] : showNums?.sloc
                                )
                                setSloc(
                                  payloadSlocDesc[_index]
                                    ? payloadSlocDesc[_index]
                                    : showNums?.sloc_desc
                                )
                                setMatgroup(
                                  payloadType[_index] ? payloadType[_index] : showNums?.product_type
                                )
                                setMatgroudesc(
                                  payloadDesc[_index]
                                    ? payloadDesc[_index]
                                    : showNums?.product_type_desc
                                )
                                setMatNumber(
                                  payloadMaterial[_index]
                                    ? payloadMaterial[_index]
                                    : showNums?.material_number
                                )
                                setMatUnit(
                                  payloadUnit[_index]
                                    ? payloadUnit[_index]
                                    : showNums?.unit
                                )
                                setMatDesc(
                                  payloadName[_index] ? payloadName[_index] : showNums?.product_name
                                )
                                setTempIndex(_index)
                                setSpec(
                                  payloadSpec[_index] ? payloadSpec[_index] : showNums?.product_spec
                                )
                                setQuantumEdit(
                                  payloadQuantum[_index]
                                    ? payloadQuantum[_index]
                                    : parseFloat(showNums?.fixed_quantum) -
                                        parseFloat(showNums?.quantum_contract)
                                )
                                setHargaEdit(
                                  payloadHarga[_index]
                                    ? payloadHarga[_index]
                                    : showNums?.fixed_price
                                )
                                setSog(
                                  showNums?.sales_org_code
                                    ? showNums?.sales_org_code
                                    : addedProduct[0]?.sales_org_code
                                )
                                setFq(showNums?.fixed_quantum)
                                setProductNameEn(showNums?.material_desc_en)
                                setPlantNameEn(showNums?.plant_desc_en)
                                setSector(showNums?.sector_id)
                                handleEdit(
                                  showNums?.sales_org_code
                                    ? showNums?.sales_org_code
                                    : addedProduct[0]?.sales_org_code,
                                  payloadMaterial[_index]
                                    ? payloadMaterial[_index]
                                    : showNums?.material_number,
                                  payloadPlantID[_index] ? payloadPlantID[_index] : showNums?.plant,
                                  payloadType[_index] ? payloadType[_index] : showNums?.product_type
                                )
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            {!showNums.id ? (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                                onClick={() => removeSubOrder(_index)}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                                onClick={() => removeSubOrderId(addedProduct[_index], _index)}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </div>
                        </td>
                        <td className='td-order-3 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {showNums.produsen?.name || showNums?.sales_org_code_desc}
                          </span>
                        </td>
                        {showNums.incoterm2 != null ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {showNums.incoterm1.code || showNums?.incoterm1_desc}-
                              {showNums.incoterm2.code}
                            </span>
                          </td>
                        ) : (
                          <>
                            {showNums?.incoterm2_id == null || showNums?.incoterm2_id == '0' ? (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {showNums.incoterm1?.code || showNums?.incoterm1_desc}
                                </span>
                              </td>
                            ) : (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {showNums?.incoterm1?.code || showNums?.incoterm1_desc}-
                                  {showNums?.incoterm2_id}
                                </span>
                              </td>
                            )}
                          </>
                        )}
                        <td className='td-order-3 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={
                                (showNums.province?.region_name || showNums?.province_desc) +
                                (showNums?.city_desc || showNums.city?.city_name
                                  ? ', ' + (showNums?.city_desc || showNums.city?.city_name)
                                  : '')
                              }
                              index={_index}
                              className='spec-sliceee'
                            />
                          </span>
                        </td>
                        {sektorid == 1 ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{t(showNums.segment_name)}</span>
                          </td>
                        ) : (
                          ''
                        )}
                        <td className='td-order-3 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={
                                showNums?.end_user_detail?.name
                                  ? showNums.end_user_detail?.name
                                  : showNums.end_user
                              }
                              index={_index}
                              className='desc-slicee'
                            />
                          </span>
                        </td>
                        <td className='td-order-3 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {t(addedProduct[0]?.sector?.name)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {payloadDesc[_index] || showNums?.product_type_desc}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {parseInt(payloadMaterial[_index]) == 0
                              ? ''
                              : payloadMaterial[_index]?.slice(-7) ||
                                showNums?.material_number.slice(-7)}
                          </span>
                        </td>
                        <td className='td-order-4 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {payloadName[_index] || showNums?.product_name}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={payloadSpec[_index] || showNums?.product_spec || '-'}
                              index={_index}
                              className='spec-sliceee'
                            />
                          </span>
                        </td>
                        {/* <td className='td-order-2 text-center column'>
                          {showNums.request_price.toLocaleString()}/1
                        </td> */}
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {i18next.language === 'en'
                              ? payloadQuantum[_index]?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) ||
                                showNums?.fixed_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : payloadQuantum[_index]?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) ||
                                showNums?.fixed_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {showNums?.product_type_desc == 'KANTONG/SACK'
                              ? showNums.unit
                              : showNums?.sector_id === 3
                              ? 'MT'
                              : 'Ton'}
                          </span>
                        </td>
                        {/* <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {!orderItems[_index]?.shipping_tolerance_contract
                              ? '0'
                              : i18next.language === 'en'
                              ? orderItems[_index]?.shipping_tolerance_contract?.toLocaleString(
                                  'en',
                                  {
                                    maximumFractionDigits: 4,
                                  }
                                )
                              : orderItems[_index]?.shipping_tolerance_contract?.toLocaleString(
                                  'id',
                                  {
                                    maximumFractionDigits: 4,
                                  }
                                )}
                            %
                          </span>
                        </td> */}
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {(showNums.sector_id == 3 ? 'USD ' : 'Rp ') + (i18next.language === 'en'
                              ? payloadHarga[_index]?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) ||
                                showNums?.fixed_price?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : payloadHarga[_index]?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) ||
                                showNums?.fixed_price?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))}
                            /
                            {showNums?.product_type_desc == 'KANTONG/SACK'
                              ? showNums.unit
                              : showNums.sector_id == 3
                              ? 'MT'
                              : 'Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {(showNums.sector_id == 3 ? 'USD ' : 'Rp ') + (i18next.language === 'en'
                              ? (
                                  payloadQuantum[_index] * payloadHarga[_index] ||
                                  showNums?.fixed_quantum * showNums?.fixed_price
                                )?.toLocaleString('en', {maximumFractionDigits: 0})
                              : (
                                  payloadQuantum[_index] * payloadHarga[_index] ||
                                  showNums?.fixed_quantum * showNums?.fixed_price
                                )?.toLocaleString('id', {maximumFractionDigits: 0}))}
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {payloadHarga[_index] != 0 ? addedProduct[0].ppn : '0'}%
                          </span>
                        </td>
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {(showNums.sector_id == 3 ? 'USD ' : 'Rp ') + (i18next.language === 'en'
                              ? (
                                  payloadQuantum[_index] *
                                    (payloadHarga[_index] +
                                      (payloadHarga[_index] / 100) * addedProduct[0].ppn) -
                                    ((payloadQuantum[_index] *
                                      (payloadHarga[_index] +
                                        (payloadHarga[_index] / 100) * addedProduct[0].ppn)) /
                                      ((addedProduct[0].ppn + 100) / 100) /
                                      100) *
                                      0 ||
                                  showNums?.fixed_quantum *
                                    (showNums?.fixed_price +
                                      (showNums?.fixed_price / 100) * addedProduct[0].ppn) -
                                    ((showNums?.fixed_quantum *
                                      (showNums?.fixed_price +
                                        (showNums?.fixed_price / 100) * addedProduct[0].ppn)) /
                                      ((addedProduct[0].ppn + 100) / 100) /
                                      100) *
                                      0
                                )?.toLocaleString('en', {maximumFractionDigits: 0})
                              : (
                                  payloadQuantum[_index] *
                                    (payloadHarga[_index] +
                                      (payloadHarga[_index] / 100) * addedProduct[0].ppn) -
                                    ((payloadQuantum[_index] *
                                      (payloadHarga[_index] +
                                        (payloadHarga[_index] / 100) * addedProduct[0].ppn)) /
                                      ((addedProduct[0].ppn + 100) / 100) /
                                      100) *
                                      0 ||
                                  showNums?.fixed_quantum *
                                    (showNums?.fixed_price +
                                      (showNums?.fixed_price / 100) * addedProduct[0].ppn) -
                                    ((showNums?.fixed_quantum *
                                      (showNums?.fixed_price +
                                        (showNums?.fixed_price / 100) * addedProduct[0].ppn)) /
                                      ((addedProduct[0].ppn + 100) / 100) /
                                      100) *
                                      0
                                )?.toLocaleString('id', {maximumFractionDigits: 0}))}
                          </span>
                        </td>
                        {/* <td className='td-order-2 text-center column ms-2'>{showNums.include_ppn ? 'Include PPN' : 'Exclude PPN'}</td> */}
                        {showNums.sector_id == 2 ? (
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {(payloadPlantID[_index] ? payloadPlantID[_index] : '') +
                                ' - ' +
                                (payloadPlantDesc[_index] ? payloadPlantDesc[_index] : '')}
                            </span>
                          </td>
                        ) : (
                          ''
                        )}
                      </tr>
                    )
                  })}
                </tbody>
              ) : null}
            </table>
            {/* End Table Head */}
          </div>

          <div style={{width: '50%'}}>
            <Row className='mb-3'>
              <Col lg={5}>
                <p className='fs-4 mt-3'>Total {t('Quantum')}</p>
              </Col>
              <Col lg={7}>
                <Form.Control
                  id='totalquantum'
                  type='text'
                  aria-label='Default select example'
                  placeholder={'Total ' + t('Quantum')}
                  defaultValue={
                    addedProduct.length < 1
                      ? ''
                      : (i18next.language === 'en'
                          ? quantumApprove?.toLocaleString('en', {maximumFractionDigits: 4})
                          : quantumApprove?.toLocaleString('id', {maximumFractionDigits: 4})) +
                        ' ' +
                        'Ton'
                  }
                  disabled
                />
              </Col>
            </Row>

            <Row className='mb-3' hidden={kantongApprove != 0 && showNum ? false : true}>
              <Col lg={5}>
                <p className='fs-4 mt-3'>Total {t('sack')}</p>
              </Col>
              <Col lg={7}>
                <Form.Control
                  id='totalquantum'
                  type='text'
                  aria-label='Default select example'
                  placeholder={'Total ' + t('sack')}
                  defaultValue={
                    addedProduct.length < 1
                      ? ''
                      : (i18next.language === 'en'
                          ? kantongApprove?.toLocaleString('en', {maximumFractionDigits: 4})
                          : kantongApprove?.toLocaleString('id', {maximumFractionDigits: 4})) +
                        ' ' +
                        punit
                  }
                  disabled
                />
              </Col>
            </Row>

            <Row className='mb-3'>
              <Col lg={5}>
                <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
              </Col>
              <Col lg={7}>
                <Form.Control
                  id='totalprice'
                  type='text'
                  aria-label='Default select example'
                  placeholder={'Total ' + t('Exclude') + ' PPN'}
                  defaultValue={
                    addedProduct.length < 1
                      ? ''
                      : (addedProduct[0]?.sector_id != 3 ? 'Rp ' : 'USD ') +
                        (i18next.language === 'en'
                          ? BeforePPNKontrak(
                              addedProduct,
                              payloadQuantum,
                              payloadHarga
                            )?.toLocaleString('en', {maximumFractionDigits: 0})
                          : BeforePPNKontrak(
                              addedProduct,
                              payloadQuantum,
                              payloadHarga
                            )?.toLocaleString('id', {maximumFractionDigits: 0}))
                  }
                  disabled
                />
              </Col>
            </Row>

            <Row className='mb-3'>
              <Col lg={5}>
                <p className='fs-4 mt-3'>Total {t('Include') + ' PPN'}</p>
              </Col>
              <Col lg={7}>
                <Form.Control
                  type='text'
                  id='total'
                  aria-label='Default select example'
                  placeholder={'Total ' + t('Include') + ' PPN'}
                  defaultValue={
                    addedProduct.length < 1
                      ? ''
                      : (addedProduct[0]?.sector_id != 3 ? 'Rp ' : 'USD ') +
                        (i18next.language === 'en'
                          ? AfterPPNKontrak(
                              addedProduct,
                              payloadQuantum,
                              payloadHarga
                            )?.toLocaleString('en', {maximumFractionDigits: 0})
                          : AfterPPNKontrak(
                              addedProduct,
                              payloadQuantum,
                              payloadHarga
                            )?.toLocaleString('id', {maximumFractionDigits: 0}))
                  }
                  disabled
                />
              </Col>
            </Row>
          </div>

          <div className='d-flex justify-content-end mt-5'>
            <Link to={'/management/kontrak'}>
              <Button className='btn btn-secondary me-2'>{t('sip-batal')}</Button>
            </Link>
            <Button
              className='btn btn-primary'
              type='submit'
              id='addKontrak'
              onClick={postKontrak}
              disabled={btnLoading}
            >
              {btnLoading ? <Spinner animation='border' size='sm' /> : t('buat')}
            </Button>
          </div>
        </div>
      </div>

      <Modal
        show={showJadwal1}
        onHide={() => (
          setShowJadwal1(false), setTempTanggal(0), setTempBulan(0), setTempTon(0), setTempTahun(0)
        )}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='xl'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {idSektor != 3 ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
            {pname} | {fixedQuantum} {ptypee == '8105' ? punit : 'Ton'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div key={tempkey}>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <div className='table-responsive bdr mt-1'>
              <table className='table-border w-100'>
                <thead>
                  <tr className='d-flex'>
                    <tr className='d-flex'>
                      {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                      <th style={{width: '165.5px'}} className='text-center'>
                        {t('order-pengambilan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tanggal')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-minggu')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-bulan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tahun')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {ptypee == '8105' ? t('sack') : t('order-tonase')}
                      </th>
                    </tr>
                  </tr>
                </thead>

                <tbody>
                  <div>
                    <tr className='d-flex'>
                      <td style={{width: '165.5px'}} className='text-center'>
                        <p className='mt-3'>{taking + 1}</p>
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        <Form.Select
                          aria-label='Default select example'
                          id='jadwaltanggal'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                        >
                          <option selected value={0} disabled hidden>
                            {t('Pilih-Tanggal')}
                          </option>
                          {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                        </Form.Select>
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        <Form.Control
                          aria-label='Default select example'
                          id='jadwalminggu'
                          placeholder={t('order-minggu')}
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          defaultValue={
                            tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)
                          }
                        />
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        <Form.Select
                          key={key}
                          aria-label='Default select example'
                          id='jadwalbulan1'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                        >
                          <option selected>{t('Pilih-Month')}</option>
                          <option value='1'>{t('Januari')}</option>
                          <option value='2'>{t('Februari')}</option>
                          <option value='3'>{t('Maret')}</option>
                          <option value='4'>{t('April')}</option>
                          <option value='5'>{t('Mei')}</option>
                          <option value='6'>{t('Juni')}</option>
                          <option value='7'>{t('Juli')}</option>
                          <option value='8'>{t('Agustus')}</option>
                          <option value='9'>{t('September')}</option>
                          <option value='10'>{t('Oktober')}</option>
                          <option value='11'>{t('November')}</option>
                          <option value='12'>{t('Desember')}</option>
                        </Form.Select>
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        <Form.Select
                          key={key}
                          aria-label='Default select example'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          id='jadwaltahun1'
                          onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                        >
                          <option selected>{t('Pilih-Year')}</option>
                          {listYear.map((data: string, index: number) => {
                            return (
                              <option key={data ?? index} value={data}>
                                {data}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        <CurrencyInput
                          id='jadwalton'
                          className='form-control form-control-sm'
                          placeholder={ptypee == '8105' ? t('sack') : t('order-tonase')}
                          key={tempTahun + key}
                          style={{width: '90%'}}
                          decimalSeparator={language === 'en' ? '.' : ','}
                          groupSeparator={language === 'en' ? ',' : '.'}
                          onValueChange={(value: any) => {
                            setTempTon(parseFloat(value?.replace(/,/g, '.')))
                          }}
                          decimalsLimit={3}
                        />
                      </td>
                    </tr>
                  </div>
                </tbody>
                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    variant='primary'
                    onClick={() => {
                      sendJadwal()
                    }}
                  >
                    {t('order-kirim')}
                  </Button>
                </div>
              </table>
            </div>
            <div
              className='table-responsive bdr mt-8'
              hidden={allJadwal?.length < 1 || allJadwal?.length == undefined ? true : false}
            >
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='border-bottom'>
                  <tr className='fw-bold '>
                    <th className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th className='text-center'>
                      {ptypee == '8105' ? t('sack') : t('order-tonase')}
                    </th>
                    <th className='text-center'>
                      {t('order-aksi')}
                    </th>
                  </tr>
                </thead>
                {allJadwal?.map((data, _index) => (
                  <tbody key={data?.date ?? _index}>
                    <tr className=''>
                      <td className='text-center'>
                        <label className='mt-3'>{_index + 1}</label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>{data.date}</label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>
                          {t('Week')}
                          {Math.ceil(data.date / 7)}
                        </label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                      </td>
                      <td className='text-center'>
                        <label className='mt-3'>{data.year}</label>
                      </td>
                      <td className='text-center'>
                        {editedIndex == _index ? (
                          <CurrencyInput
                            id='ton'
                            placeholder={ptypee == '8105' ? t('sack') : t('order-tonase')}
                            className='form-control form-control-sm'
                            defaultValue={data.tonnage}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        ) : (
                          <label className='mt-3'>
                            {(i18next.language === 'en'
                              ? data?.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data?.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' '}
                            {ptypee == '8105' ? punit : 'Ton'}
                          </label>
                        )}
                      </td>
                      <td className='text-center'>
                        {editedIndex == _index ? (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Approve')}
                            onClick={() => rubahSchedule(_index, tempTon, data.tonnage)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/check-square.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        ) : (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('ubah')}
                            onClick={() => {
                              setEditedIndex(_index)
                              setTempTon(data.tonnage)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/pencil-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}

                        <button
                          onClick={() => hapusSchedule(_index)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showJadwal}
        onHide={() => {
          setShowJadwal(false)
          setJadwalID('')
        }}
        centered
        size='xl'
        backdrop='static'
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
            {productName} | {fixedQuantum} {ptypee != '8105' ? 'Ton' : punit}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddRemoveJadwal id={jadwalID} is_amendment={'false'} tipeproduct={ptypee} unit={punit} />
        </Modal.Body>
      </Modal>

      <Modal
        size='lg'
        show={show6}
        onHide={() => {
          setShow6(false)
          setIsPrivate(false)
          setTempRole([])
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingSkeleton ? (
            <>
              <Col lg={6}>
                <Skeleton count={3} height={30} />
              </Col>
            </>
          ) : (
            <>
              <Row>
                <Col sm={6}>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-fileUnggah')}</h6>
                      </td>
                      <td className='w-75'>
                        <InputFile
                            setFileName={setNamaFile}
                            setFiles={setFiless}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-keterangan')}</h6>
                      </td>
                      <td className='w-75'>
                        <Form.Control
                          type='text'
                          key={key}
                          id='uploadketerangan'
                          placeholder={t('order-keterangan')}
                          onChange={(e: any) => setDescription(e.target.value)}
                        />
                      </td>
                    </tr>
                  </table>
                  <table
                    className='mb-3'
                    hidden={roleUser == 'null' || roleUser == null ? true : false}
                  >
                    <tr>
                      <td>
                        <h6 className='me-11'>{t('Private')}</h6>
                      </td>
                      <td className='w-75 d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='isPrivate'
                          type='checkbox'
                          className='mt-5 mb-2'
                          onClick={() => {
                            setIsPrivate(!isPrivate)
                            setTempRole([])
                          }}
                          id='isPrivate1'
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3' hidden={isPrivate ? false : true}>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('Akses Role')}</h6>
                      </td>
                      <td className='w-75' style={{maxWidth: '274px'}}>
                        <MultiSelect
                          key={isPrivate.toString()}
                          options={fullRole?.map((item: any) => {
                            return {label: item.label, value: item.value}
                          })}
                          value={tempRole}
                          onChange={(e: any) => setTempRole(e)}
                          labelledBy='Select'
                        />
                      </td>
                    </tr>
                  </table>
                  <div className='d-flex justify-content-end'>
                    {uploadType == 'header' ? (
                      <Button variant='primary' className='w-100' onClick={() => handleUpload()}>
                        {t('order-kirim')}
                      </Button>
                    ) : (
                      <Button variant='primary' className='w-100' onClick={() => handleUpload2()}>
                        {t('order-kirim')}
                      </Button>
                    )}
                  </div>
                </Col>
                <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {uploadType == 'header' ? (
                      <>
                        {fileHeader
                          .slice(0)
                          .reverse()
                          .map((data: any, _index: number) => (
                            <tbody key={data?.datenow ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(getCurrentFormattedDate())}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>
                                    {localStorage.getItem('cust-code') !== 'null'
                                      ? localStorage.getItem('cust-code')
                                      : localStorage.getItem('user_code')}
                                  </label>
                                </td> */}
                                <td className='text-center'>
                                  <label>{localStorage.getItem('username')}</label>
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleNameFromState(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('unduh')}
                                    onClick={() => handleDownloadBase64(data.file_r)}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteUploadHeader(
                                        fileHeader.length - 1 - _index,
                                        fileHeader,
                                        setFileHeader,
                                        'header',
                                        tempData,
                                        setTempData
                                      )
                                    }
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </>
                    ) : (
                      <>
                        {orderItemFiles
                          ?.slice(0)
                          .reverse()
                          .map((data: any, _index: number) => (
                            <tbody key={data?.datenow ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(getCurrentFormattedDate())}</label>
                                </td>
                                <td className='text-center'>
                                  <label>
                                    {localStorage.getItem('cust-code') !== 'null'
                                      ? localStorage.getItem('cust-code')
                                      : localStorage.getItem('user_code')}
                                  </label>
                                </td>
                                <td className='text-center'>
                                  <label>{localStorage.getItem('username')}</label>
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleNameFromState(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('unduh')}
                                    onClick={() => handleDownloadBase64(data.file_r)}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteUploadHeader(
                                        orderItemFiles.length - 1 - _index,
                                        orderItemFiles,
                                        setOrderItemsFiles,
                                        'order-item',
                                        tempData,
                                        setTempData
                                      )
                                    }
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </>
                    )}
                  </table>
                </div>
              </Row>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => {
          setShowUpload(false)
          setIsPrivate(false)
          setTempRole([])
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('order-fileUnggah')}</h6>
                  </td>
                  <td className='w-75'>
                    <InputFile
                        setFileName={setNamaFile}
                        setFiles={setFiles}
                        isBase64={false}
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('order-keterangan')}</h6>
                  </td>
                  <td className='w-75'>
                    <Form.Control
                      type='text'
                      placeholder={t('order-keterangan')}
                      onChange={(e: any) => setDescription(e.target.value)}
                      value={description}
                    />
                  </td>
                </tr>
              </table>
              <table
                className='mb-3'
                hidden={roleUser == 'null' || roleUser == null ? true : false}
              >
                <tr>
                  <td>
                    <h6 className='me-11'>{t('Private')}</h6>
                  </td>
                  <td className='w-75 d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='isPrivate'
                      type='checkbox'
                      className='mt-5 mb-2'
                      onClick={() => {
                        setIsPrivate(!isPrivate)
                        setTempRole([])
                      }}
                      id='isPrivate2'
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3' hidden={isPrivate ? false : true}>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('Akses Role')}</h6>
                  </td>
                  <td className='w-75' style={{maxWidth: '274px'}}>
                    <MultiSelect
                      key={isPrivate.toString()}
                      options={fullRole?.map((item: any) => {
                        return {label: item.label, value: item.value}
                      })}
                      value={tempRole}
                      onChange={(e: any) => setTempRole(e)}
                      labelledBy='Select'
                    />
                  </td>
                </tr>
              </table>
              <div className='d-flex justify-content-end'>
                <Button
                  variant='primary'
                  className='w-100'
                  onClick={() => handleUpload()}
                  disabled={btnLoadingA}
                >
                  {btnLoadingA ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('order-kirim')
                  )}
                </Button>
              </div>
            </Col>
          </Row>
          <div className='table-responsive mt-4 bdr'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead className='fw-bold border-bottom'>
                <tr className=''>
                  <th className='text-center'>{t('order-noo')}</th>
                  <th className='text-center'>{t('order-keterangan')}</th>
                  <th className='text-center'>{t('order-tglUpload')}</th>
                  {/* <th className='text-center'>{t('User Code')}</th> */}
                  <th className='text-center'>{t('order-user')}</th>
                  <th className='text-center'>{t('Akses Role')}</th>
                  <th className='text-center'>{t('order-aksi')}</th>
                </tr>
              </thead>
              {allFiles.map((data: any, _index: number) => (
                <tbody key={data?.id ?? _index}>
                  <tr className=''>
                    <td className='text-center'>
                      <label>{_index + 1}</label>
                    </td>
                    <td className='text-center'>
                      <label>{data.description}</label>
                    </td>
                    <td className='text-center'>
                      <label>{dateformat(data.updated_at)}</label>
                    </td>
                    {/* <td className='text-center'>
                      <label>
                        {localStorage.getItem('cust-code') !== 'null'
                          ? localStorage.getItem('cust-code')
                          : localStorage.getItem('user_code')}
                      </label>
                    </td> */}
                    <td className='text-center'>
                      {data.user?.customer_code == null ? (
                        <label>{data.user?.name}</label>
                      ) : (
                        <label>{data.user?.customer?.name}</label>
                      )}
                    </td>
                    <td className='text-center'>
                      {data.private ? (
                        data.roles.length > 0 ? (
                          <PopoverText
                            content={handleShowRoleName(data.roles)}
                            index={_index}
                            className='desc-slice'
                          />
                        ) : (
                          'Private'
                        )
                      ) : (
                        'Public'
                      )}
                    </td>
                    <td className='text-center'>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('unduh')}
                        onClick={() =>
                          handleDownloadAttachment(data.file_path)
                        }
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrow-down-square-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      {(hakAkses?.attachment_delete ||
                        CheckSameIDAttachment(data.user_role_flag)) && (
                        <button
                          onClick={() => deleteAttachment(data.id)}
                          className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={show3} onHide={handleClose3} size='lg' centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('Edit')} Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-gudang')}</Form.Label>
                <Select
                  key={trigger}
                  placeholder={t('pilih') + ' ' + t('sub-order-gudang')}
                  onChange={(e: any) => {
                    separator(e.value, setPlant, setPlantDesc)
                    setPlantt(e.value)
                    setPlanttt(e.value)
                    setFullSloc([])

                    const plant = e?.value?.split('~#~')[0] ?? ''
                    const plant_desc = e?.value?.split('~#~')[1] ?? ''
                    if(sector == '3'){
                      setPlantNameEn(plant_desc)
                    }
                    dispatch(
                      setOrderItem({...(orderItem as TOrderItemContract), plant, plant_desc})
                    )
                  }}
                  options={fullPlant}
                  value={fullPlant.find((x: any) => x.value == plantt)}
                />
              </Form.Group>

              { sector == '3' && <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-gudang')} (EN)</Form.Label>
                <Form.Control
                  aria-label='Default select example'
                  value={plantNameEn}
                  style={{height: '40px'}}
                  onChange={(e: any) => {
                    const plantEn = e.target.value
                    setPlantNameEn(plantEn)
                    dispatch(setOrderItem({
                      ...(orderItem as TOrderItemContract),
                      plant_desc_en: plantEn
                    }))
                  }}
                  key={plant + matNumber}
                />
              </Form.Group> }
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('storage location')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  onChange={(e: any) => {
                    separator(e.target.value, setslocId, setSloc)

                    const sloc = e.target.value.split('~#~')[0]
                    const sloc_description = e.target.value.split('~#~')[1]
                    dispatch(
                      setOrderItem({
                        ...(orderItem as TOrderItemContract),
                        sloc,
                        sloc_description,
                      })
                    )
                  }}
                  id='sloccc'
                  key={plant + matNumber + matDesc}
                >
                  <option value=''>
                    {t('pilih')} {t('storage location')}
                  </option>
                  {fullsloc?.map((item: any) => {
                    return (
                      <>
                        {item.sloc == slocId ? (
                          <option selected value={item.sloc + '~#~' + item.sloc_description}>
                            {item.sloc + ' - ' + item.sloc_description}
                          </option>
                        ) : (
                          <option value={item.sloc + '~#~' + item.sloc_description}>
                            {item.sloc + ' - ' + item.sloc_description}
                          </option>
                        )}
                      </>
                    )
                  })}
                </Form.Select>
              </Form.Group>
              {planttt && (
                <>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('kontrak-jenis')}</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      onChange={(e: any) => {
                        separator(e.target.value, setMatgroup, setMatgroudesc)
                        setMatDesc('')
                        setMatNumber('')

                        const product_type = e.target.value.split('~#~')[0]
                        const product_type_desc = e.target.value.split('~#~')[1]
                        dispatch(
                          setOrderItem({
                            ...(orderItem as TOrderItemContract),
                            product_type,
                            product_type_desc,
                          })
                        )
                      }}
                    >
                      <option value=''>
                        {t('pilih')} {t('kontrak-jenis')}
                      </option>
                      {listMaterial?.map((item: any) => {
                        return (
                          <>
                            {item.material_group == matgroup ? (
                              <option
                                selected
                                value={item.material_group + '~#~' + item.material_group_desc}
                              >
                                {item.material_group + ' - ' + item.material_group_desc}
                              </option>
                            ) : (
                              <option value={item.material_group + '~#~' + item.material_group_desc}>
                                {item.material_group + ' - ' + item.material_group_desc}
                              </option>
                            )}
                          </>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-produk')}</Form.Label>
                    <Select
                      key={listProduct + matDesc}
                      placeholder={t('pilih') + ' ' + t('sub-order-produk')}
                      onChange={(e: any) => {
                        separator(e.value, setMatDesc, setMatNumber)

                        const product_name = e.value.split('~#~')[0]
                        setMatUnit(e.unit)
                        if(sector == '3'){
                          setProductNameEn(product_name)
                        }
                        dispatch(setOrderItem({...(orderItem as TOrderItemContract), product_name}))
                      }}
                      options={listProduct}
                      defaultValue={
                        listProduct[listProduct.findIndex((x: any) => x.value == matDesc+"~#~"+matNumber)]
                      }
                    />
                  </Form.Group>
                  { sector == '3' && <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-produk')} (EN)</Form.Label>
                    <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      value={productNameEn}
                      style={{height: '40px'}}
                      onChange={(e: any) => {
                        const prodeN = e.target.value
                        setProductNameEn(prodeN)
                        dispatch(setOrderItem({
                          ...(orderItem as TOrderItemContract),
                          material_desc_en: prodeN
                        }))
                      }}
                      key={plant + matNumber}
                    />
                  </Form.Group> }
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-spek')}</Form.Label>
                    <div>
                      <RichText
                        containerClassName='mt-4'
                        content={spec}
                        onUpdate={({editor}) => {
                          setSpec(editor.getHTML())
                          const product_spec = editor.getHTML()
                          dispatch(
                            setOrderItem({...(orderItem as TOrderItemContract), product_spec})
                          )
                        }}
                      >
                        &nbsp;
                      </RichText>
                    </div>
                    {/* <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      style={{height: '40px'}}
                      onChange={(e: any) => {
                        const product_spec = e.target.value
                        setSpec(product_spec)
                        dispatch(setOrderItem({...(orderItem as TOrderItemContract), product_spec}))
                      }}
                      defaultValue={spec}
                      key={plant + matNumber}
                    /> */}
                  </Form.Group>

                  { (orderItem?.has_usd_price && orderItem?.price_usd != '0') && <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('kontrak-harga')} USD</Form.Label>
                    <InputGroup>
                      <InputGroup.Text id='basic-addon1'>
                        USD
                      </InputGroup.Text>
                      <CurrencyInput
                        id='rp'
                        placeholder={t('kontrak-harga')}
                        className='form-control form-control-sm'
                        defaultValue={orderItem?.price_usd}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        disabled={true}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        decimalsLimit={2}
                      />
                    </InputGroup>
                  </Form.Group> }

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('kontrak-harga')}</Form.Label>
                    <InputGroup>
                      <InputGroup.Text id='basic-addon1'>
                        {sektorid != 3 ? 'Rp' : 'USD'}
                      </InputGroup.Text>
                      <CurrencyInput
                        id='rp'
                        placeholder={t('kontrak-harga')}
                        className='form-control form-control-sm'
                        defaultValue={hargaEdit}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {
                          const fixed_price = parseFloat(value?.replace(/,/g, '.'))
                          setHargaEdit(fixed_price)
                          dispatch(
                            setOrderItem({...(orderItem as TOrderItemContract), fixed_price})
                          )
                        }}
                        decimalsLimit={sektorid != 3 ? -1 : 2}
                      />
                    </InputGroup>
                  </Form.Group>

                  {/* <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.STATUS_PRICE_LABEL')}
                    </Form.Label>
                    <Form.Control
                      defaultValue={orderItem?.include_ppn ? 'include PPN' : 'exclude PPN'}
                      disabled
                    />
                  </Form.Group> */}

                  <Row>
                    <Col md='6'>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>
                          {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.TOTAL_QUANTUM_LABEL')}
                        </Form.Label>
                        <Form.Control
                          aria-label='Default select example'
                          defaultValue={orderItem?.quantum_contract ?? ''}
                          disabled
                          key={plant + matNumber}
                        />
                      </Form.Group>
                    </Col>
                    <Col md='6'>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('sisaquantum')}</Form.Label>
                        <Form.Control
                          aria-label='Default select example'
                          defaultValue={kuantumSisa || ''}
                          disabled
                          key={plant + matNumber}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md='6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>
                          {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.QUANTUM_SIP_LABEL')}
                        </Form.Label>
                        <InputGroup>
                          <CurrencyInput
                            disabled
                            className='form-control form-control-sm'
                            defaultValue={orderItem?.is_new ? '' : orderItem?.fixed_quantum}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text>Ton</InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>

                    <Col md='6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>
                          {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.TOLERANCE_SIP_LABEL')}
                        </Form.Label>
                        <InputGroup>
                          <CurrencyInput
                            disabled
                            className='form-control form-control-sm'
                            defaultValue={
                              orderItem?.is_new ? '' : orderItem?.shipping_tolerance ?? ''
                            }
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md='6'>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>
                          {matgroup == '8105'
                            ? t('sack')
                            : t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL')}
                        </Form.Label>
                        <InputGroup>
                          <CurrencyInput
                            id='ton'
                            placeholder={
                              matgroup == '8105'
                                ? t('sack')
                                : t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL')
                            }
                            className='form-control form-control-sm'
                            defaultValue={kuantumSisa || orderItem?.fixed_quantum}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              const fixed_quantum = parseFloat(value?.replace(/,/g, '.'))
                              setQuantumEdit(fixed_quantum)
                              dispatch(
                                setOrderItem({...(orderItem as TOrderItemContract), fixed_quantum})
                              )
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon1'>
                            {matgroup == '8105' ? punit : 'Ton'}
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md='6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>
                          {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SHIPPING_TOLERANCE_LABEL')}
                        </Form.Label>
                        <InputGroup>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            value={orderItem?.shipping_tolerance_contract || '0'}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            decimalsLimit={3}
                            onValueChange={(v: any) => {
                              const shipping_tolerance_contract = parseFloat(v?.replace(/,/g, '.'))
                              setShipContract(shipping_tolerance_contract)
                              dispatch(
                                setOrderItem({
                                  ...(orderItem as TOrderItemContract),
                                  shipping_tolerance_contract,
                                })
                              )
                            }}
                          />
                          <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('CREATE_CONTRACT.EDIT_ITEM_MODAL.NOTE_LABEL')}</Form.Label>
                    <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      value={salesOption}
                      style={{height: '40px'}}
                      onChange={(e: any) => {
                        const notes = e.target.value
                        setSalesOption(notes)
                        dispatch(setOrderItem({...(orderItem as TOrderItemContract), notes}))
                      }}
                      key={plant + matNumber}
                    />
                  </Form.Group>
                </>
              )}
              <div className='d-flex justify-content-end mt-5'>
                <Button onClick={() => handleEditPlant()}>{t('Save')}</Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} centered scrollable size='xl' backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sektorid == 1 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>Sales Org</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail.produsen?.name || tempDetail.sales_org_code_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail.incoterm1?.code || tempDetail.incoterm1_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={tempDetail.province?.region_name || tempDetail.province_desc}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={payloadDesc[tempIndex] || tempDetail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={
                        payloadPlantID[tempIndex] == null
                          ? ''
                          : payloadPlantID[tempIndex] + ' - ' + payloadPlantDesc[tempIndex] ||
                            tempDetail.plant + ' - ' + tempDetail.plant_desc
                      }
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>
                      {tempDetail.product_type_desc == 'KANTONG/SACK'
                        ? t('sack')
                        : t('CREATE_CONTRACT.ADD_ITEM_MODAL.QUANTUM_SIP_LABEL')}
                    </p>
                  </Col>
                  <Col md={7}>
                    {tempDetail.product_type_desc == 'KANTONG/SACK' ? (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                            : parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                            : parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                {tempDetail.quantum_contract && (
                  <Row className='mb-4'>
                    <Col md={5}>
                      <p className='mt-3 fs-6'>
                        {tempDetail.product_type_desc == 'KANTONG/SACK'
                          ? t('sack')
                          : t('CREATE_CONTRACT.ADD_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL')}
                      </p>
                    </Col>
                    <Col md={7}>
                      {tempDetail.product_type_desc == 'KANTONG/SACK' ? (
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? parseFloat(tempDetail.quantum_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                              : parseFloat(tempDetail.quantum_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? parseFloat(tempDetail.quantum_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                              : parseFloat(tempDetail.quantum_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                )}
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                  </Col>
                  <Col sm={7}>
                    <Form.Control
                      size='sm'
                      type='text'
                      id='shipping'
                      value={
                        tempDetail?.shipping_tolerance != '0'
                          ? tempDetail?.shipping_tolerance + ' %'
                          : ''
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail?.payment_type_1_desc || tempDetail?.payment_type_1}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      as='textarea'
                      value={t(tempDetail?.payment_note || tempDetail?.payment_notes)}
                      disabled
                      size='sm'
                      style={{height: '40px'}}
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        tempDetail.end_user_detail?.name
                          ? tempDetail.end_user_detail?.name
                          : tempDetail.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={t(tempDetail.sector?.name || 'Domestik Korperasi')}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={7}>
                    {tempDetail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                            ? ''
                            : tempDetail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={tempDetail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={tempDetail?.city?.city_name || tempDetail?.city_desc}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        payloadMaterial[tempIndex]
                          ? payloadMaterial[tempIndex]?.slice(-7) + '-' + payloadName[tempIndex]
                          : tempDetail?.material_number?.slice(-7) + '-' + tempDetail?.product_name
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={7} className='d-flex align-items-center'>
                    <FieldProductSpec
                      data={payloadSpec[tempIndex] || tempDetail.product_spec}
                      type='editor'
                    />
                    {/* <Form.Control
                      as='textarea'
                      style={{height: '40px'}}
                      value={stripHtmlTags(payloadSpec[tempIndex] || tempDetail.product_spec)}
                      type='text'
                      disabled
                      size='sm'
                    /> */}
                  </Col>
                </Row>
                <Row className='mb-2'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>
                      {t('sub-order-hargaD')}/
                      {tempDetail.product_type_desc == 'KANTONG/SACK' ? tempDetail.unit : 'Ton'}
                    </p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        'Rp' + i18next.language === 'en'
                          ? parseInt(
                              payloadHarga[tempIndex] || tempDetail?.fixed_price
                            ).toLocaleString('en', {maximumFractionDigits: 4})
                          : parseInt(
                              payloadHarga[tempIndex] || tempDetail?.fixed_price
                            ).toLocaleString('id', {maximumFractionDigits: 4})
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                {tempDetail.quantum_contract && (
                  <Row className='mb-4'>
                    <Col md={5}>
                      <p className='mt-3 fs-6'>
                        {tempDetail.product_type_desc == 'KANTONG/SACK'
                          ? t('sack')
                          : t('sisaquantum')}
                      </p>
                    </Col>
                    <Col md={7}>
                      {tempDetail.product_type_desc == 'KANTONG/SACK' ? (
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.quantum_contract)
                                ).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                              : (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.quantum_contract)
                                ).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' EA'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.quantum_contract)
                                ).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                              : (
                                  parseFloat(tempDetail.fixed_quantum) -
                                  parseFloat(tempDetail.quantum_contract)
                                ).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                )}
                <Row className='mb-5'>
                  <Col md={5}>
                    <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                  </Col>
                  <Col sm={7} className='d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='ppn'
                      className='mt-4 mb-2'
                      type='checkbox'
                      id='ckbox-ppn'
                      checked={tempDetail?.include_ppn}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail?.payment_type_2_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('segment')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={t(tempDetail.segment_name)}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail?.notes}
                      as='textarea'
                      style={{height: '40px'}}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}

          {sektorid == 3 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>Sales Org</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail.produsen?.name || tempDetail.sales_org_code_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail.incoterm1?.code || tempDetail.incoterm1_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={tempDetail.province?.region_name || tempDetail.province_desc}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={payloadDesc[tempIndex] || tempDetail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={
                        payloadPlantID[tempIndex] == null
                          ? ''
                          : payloadPlantID[tempIndex] + ' - ' + payloadPlantDesc[tempIndex] ||
                            tempDetail.plant + ' - ' + tempDetail.plant_desc
                      }
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>
                      {tempDetail.product_type_desc == 'KANTONG/SACK'
                        ? t('sack')
                        : t('sub-order-kuantum')}
                    </p>
                  </Col>
                  <Col md={7}>
                    {tempDetail.product_type_desc == 'KANTONG/SACK' ? (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                            : parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                            : parseFloat(
                                payloadQuantum[tempIndex] || tempDetail.fixed_quantum
                              ).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                  </Col>
                  <Col sm={7}>
                    <Form.Control
                      size='sm'
                      type='text'
                      id='shipping'
                      value={
                        tempDetail?.shipping_tolerance != '0'
                          ? tempDetail?.shipping_tolerance + ' %'
                          : ''
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail?.payment_type_1_desc || tempDetail?.payment_type_1}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      as='textarea'
                      value={t(tempDetail?.payment_note || tempDetail?.payment_notes)}
                      disabled
                      size='sm'
                      style={{height: '40px'}}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={t(tempDetail.sector?.name || 'Ekspor')}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={7}>
                    {tempDetail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                            ? ''
                            : tempDetail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={tempDetail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={tempDetail?.city?.city_name || tempDetail?.city_desc}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        payloadMaterial[tempIndex]
                          ? payloadMaterial[tempIndex]?.slice(-7) + '-' + payloadName[tempIndex]
                          : tempDetail?.material_number?.slice(-7) + '-' + tempDetail?.product_name
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={7}>
                    <FieldProductSpec
                      data={payloadSpec[tempIndex] || tempDetail.product_spec}
                      type='editor'
                    />
                  </Col>
                </Row>
                <Row className='mb-2'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>
                      {t('sub-order-hargaD')}/
                      {tempDetail.product_type_desc == 'KANTONG/SACK' ? tempDetail.unit : 'MT'}
                    </p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        'USD' + i18next.language === 'en'
                          ? parseFloat(
                              payloadHarga[tempIndex] || tempDetail?.fixed_price
                            ).toLocaleString('en', {maximumFractionDigits: 4})
                          : parseFloat(
                              payloadHarga[tempIndex] || tempDetail?.fixed_price
                            ).toLocaleString('id', {maximumFractionDigits: 4})
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                {/* <Row className='mb-5'>
                  <Col md={5}>
                    <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                  </Col>
                  <Col sm={7} className='d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='ppn'
                      className='mt-4 mb-2'
                      type='checkbox'
                      id='ckbox-ppn'
                      checked={tempDetail?.include_ppn}
                    />
                  </Col>
                </Row> */}
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail?.notes}
                      as='textarea'
                      style={{height: '40px'}}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={tempDetail?.payment_type_2_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        tempDetail.end_user_detail?.name
                          ? tempDetail.end_user_detail?.name
                          : tempDetail.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export {KontrakCreate}
